/**
 * @public
 */

/**
 * @public
 */

/**
 * Prompt parameter options.
 *
 * @public
 */

/**
 * @internal
 */

/**
 * @internal
 */

/**
 * @internal
 */

/**
 * @internal
 */

/**
 * @internal
 */
function _decodeUserInfo(r) {
  var _r$custom_attributes, _r$httpsAuthgearC, _r$httpsAuthgearC2, _r$httpsAuthgearC3, _r$address, _r$address2, _r$address3, _r$address4, _r$address5, _r$address6;

  var raw = r;
  var customAttributes = (_r$custom_attributes = r["custom_attributes"]) != null ? _r$custom_attributes : {};
  return {
    sub: r["sub"],
    isVerified: (_r$httpsAuthgearC = r["https://authgear.com/claims/user/is_verified"]) != null ? _r$httpsAuthgearC : false,
    isAnonymous: (_r$httpsAuthgearC2 = r["https://authgear.com/claims/user/is_anonymous"]) != null ? _r$httpsAuthgearC2 : false,
    canReauthenticate: (_r$httpsAuthgearC3 = r["https://authgear.com/claims/user/can_reauthenticate"]) != null ? _r$httpsAuthgearC3 : false,
    raw: raw,
    customAttributes: customAttributes,
    email: r["email"],
    emailVerified: r["email_verified"],
    phoneNumber: r["phone_number"],
    phoneNumberVerified: r["phone_number_verified"],
    preferredUsername: r["preferred_username"],
    familyName: r["family_name"],
    givenName: r["given_name"],
    middleName: r["middle_name"],
    name: r["name"],
    nickname: r["nickname"],
    picture: r["picture"],
    profile: r["profile"],
    website: r["website"],
    gender: r["gender"],
    birthdate: r["birthdate"],
    zoneinfo: r["zoneinfo"],
    locale: r["locale"],
    address: {
      formatted: (_r$address = r["address"]) == null ? void 0 : _r$address["formatted"],
      streetAddress: (_r$address2 = r["address"]) == null ? void 0 : _r$address2["street_address"],
      locality: (_r$address3 = r["address"]) == null ? void 0 : _r$address3["locality"],
      region: (_r$address4 = r["address"]) == null ? void 0 : _r$address4["region"],
      postalCode: (_r$address5 = r["address"]) == null ? void 0 : _r$address5["postal_code"],
      country: (_r$address6 = r["address"]) == null ? void 0 : _r$address6["country"]
    }
  };
}
/**
 * @internal
 */

/**
 * @public
 */
var Page;

(function (Page) {
  Page["Settings"] = "/settings";
  Page["Identities"] = "/settings/identities";
})(Page || (Page = {}));

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$2()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * AuthgearError is the root class of error produced by the SDK.
 *
 * @public
 */
var AuthgearError = /*#__PURE__*/function (_Error) {
  _inherits(AuthgearError, _Error);

  var _super = _createSuper$1(AuthgearError);

  function AuthgearError() {
    return _super.apply(this, arguments);
  }

  return _createClass(AuthgearError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * ErrorNames contains all possible name in {@link ServerError}
 *
 * @public
 */

var ErrorNames = {
  BadRequest: "BadRequest",
  Invalid: "Invalid",
  Unauthorized: "Unauthorized",
  Forbidden: "Forbidden",
  NotFound: "NotFound",
  AlreadyExists: "AlreadyExists",
  TooManyRequest: "TooManyRequest",
  InternalError: "InternalError",
  ServiceUnavailable: "ServiceUnavailable"
};
/**
 * ErrorName is the union of the keys of {@link ErrorNames}.
 *
 * @public
 */

/**
 * CancelError means cancel.
 * If you catch an error and it is instanceof CancelError,
 * then the operation was cancelled.
 *
 * @public
 */
var CancelError = /*#__PURE__*/function (_AuthgearError) {
  _inherits(CancelError, _AuthgearError);

  var _super2 = _createSuper$1(CancelError);

  function CancelError() {
    return _super2.apply(this, arguments);
  }

  return _createClass(CancelError);
}(AuthgearError);
/**
 * ServerError represents error received from the server.
 *
 * @public
 */

var ServerError = /*#__PURE__*/function (_AuthgearError2) {
  _inherits(ServerError, _AuthgearError2);

  var _super3 = _createSuper$1(ServerError);

  /**
   * Error name.
   *
   * @remarks
   * See {@link ErrorNames} for possible values.
   * New error names may be added in future.
   */

  /**
   * Error message.
   *
   * @remarks
   * Error messages are provided for convenience, and not stable APIs;
   * Consumers should use {@link ServerError.name} or
   * {@link ServerError.reason} to distinguish between different errors.
   */

  /**
   * Error reason.
   */

  /**
   * Additional error information.
   */
  function ServerError(message, name, reason, info) {
    var _this;

    _this = _super3.call(this, message);
    _this.name = name;
    _this.reason = reason;
    _this.info = info;
    return _this;
  }

  return _createClass(ServerError);
}(AuthgearError);
/**
 * OAuthError represents the oauth error response.
 * https://tools.ietf.org/html/rfc6749#section-4.1.2.1
 *
 * @public
 */

var OAuthError = /*#__PURE__*/function (_AuthgearError3) {
  _inherits(OAuthError, _AuthgearError3);

  var _super4 = _createSuper$1(OAuthError);

  function OAuthError(_ref) {
    var _this2;

    var state = _ref.state,
        error = _ref.error,
        error_description = _ref.error_description,
        error_uri = _ref.error_uri;
    _this2 = _super4.call(this, error + (error_description != null ? ": " + error_description : ""));
    _this2.state = state;
    _this2.error = error;
    _this2.error_description = error_description;
    _this2.error_uri = error_uri;
    return _this2;
  }

  return _createClass(OAuthError);
}(AuthgearError);
/**
 * @internal
 */
// eslint-disable-next-line complexity

function _decodeError(err) {
  // Construct ServerError if it looks like one.
  if (err != null && !(err instanceof Error) && typeof err.name === "string" && typeof err.reason === "string" && typeof err.message === "string") {
    return new ServerError(err.message, err.name, err.reason, err.info);
  } // If it is an Error, just return it.


  if (err instanceof Error) {
    return err;
  } // If it has message, construct an Error from the message.


  if (err != null && typeof err.message === "string") {
    return new Error(err.message);
  } // If it can be turned into string, use it as message.


  if (err != null && typeof err.toString === "function") {
    return new Error(err.toString());
  } // Otherwise cast it to string and use it as message.


  return new Error(String(err));
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));

var regenerator = runtime.exports;

var fails$g = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString$3 = {}.toString;

var classofRaw$3 = function (it) {
  return toString$3.call(it).slice(8, -1);
};

var fails$f = fails$g;
var classof$9 = classofRaw$3;

var split$1 = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject$1 = fails$f(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) == 'String' ? split$1.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject$1;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$9 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

var iterators$1 = {};

var check$1 = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$j =
  // eslint-disable-next-line no-undef
  check$1(typeof globalThis == 'object' && globalThis) ||
  check$1(typeof window == 'object' && window) ||
  check$1(typeof self == 'object' && self) ||
  check$1(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails$e = fails$g;

// Thank's IE8 for his funny defineProperty
var descriptors$1 = !fails$e(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectDefineProperty$1 = {};

var isObject$d = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var global$i = global$j;
var isObject$c = isObject$d;

var document$2 = global$i.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$c(document$2) && isObject$c(document$2.createElement);

var documentCreateElement$3 = function (it) {
  return EXISTS$1 ? document$2.createElement(it) : {};
};

var DESCRIPTORS$b = descriptors$1;
var fails$d = fails$g;
var createElement$1 = documentCreateElement$3;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine$1 = !DESCRIPTORS$b && !fails$d(function () {
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var isObject$b = isObject$d;

var anObject$e = function (it) {
  if (!isObject$b(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var isObject$a = isObject$d;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$6 = function (input, PREFERRED_STRING) {
  if (!isObject$a(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$a(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$a(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$a(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var DESCRIPTORS$a = descriptors$1;
var IE8_DOM_DEFINE$3 = ie8DomDefine$1;
var anObject$d = anObject$e;
var toPrimitive$5 = toPrimitive$6;

var nativeDefineProperty$1 = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty$1.f = DESCRIPTORS$a ? nativeDefineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$d(O);
  P = toPrimitive$5(P, true);
  anObject$d(Attributes);
  if (IE8_DOM_DEFINE$3) try {
    return nativeDefineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var createPropertyDescriptor$a = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$9 = descriptors$1;
var definePropertyModule$4 = objectDefineProperty$1;
var createPropertyDescriptor$9 = createPropertyDescriptor$a;

var createNonEnumerableProperty$d = DESCRIPTORS$9 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$9(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var global$h = global$j;
var createNonEnumerableProperty$c = createNonEnumerableProperty$d;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$c(global$h, key, value);
  } catch (error) {
    global$h[key] = value;
  } return value;
};

var global$g = global$j;
var setGlobal$2 = setGlobal$3;

var SHARED$1 = '__core-js_shared__';
var store$7 = global$g[SHARED$1] || setGlobal$2(SHARED$1, {});

var sharedStore$1 = store$7;

var store$6 = sharedStore$1;

var functionToString$1 = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$6.inspectSource != 'function') {
  store$6.inspectSource = function (it) {
    return functionToString$1.call(it);
  };
}

var inspectSource$3 = store$6.inspectSource;

var global$f = global$j;
var inspectSource$2 = inspectSource$3;

var WeakMap$3 = global$f.WeakMap;

var nativeWeakMap$1 = typeof WeakMap$3 === 'function' && /native code/.test(inspectSource$2(WeakMap$3));

var hasOwnProperty$1 = {}.hasOwnProperty;

var has$g = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var shared$5 = {exports: {}};

var isPure$1 = true;

var store$5 = sharedStore$1;

(shared$5.exports = function (key, value) {
  return store$5[key] || (store$5[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: 'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id$1 = 0;
var postfix$1 = Math.random();

var uid$5 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix$1).toString(36);
};

var shared$4 = shared$5.exports;
var uid$4 = uid$5;

var keys$1 = shared$4('keys');

var sharedKey$7 = function (key) {
  return keys$1[key] || (keys$1[key] = uid$4(key));
};

var hiddenKeys$7 = {};

var NATIVE_WEAK_MAP$1 = nativeWeakMap$1;
var global$e = global$j;
var isObject$9 = isObject$d;
var createNonEnumerableProperty$b = createNonEnumerableProperty$d;
var objectHas$1 = has$g;
var sharedKey$6 = sharedKey$7;
var hiddenKeys$6 = hiddenKeys$7;

var WeakMap$2 = global$e.WeakMap;
var set$1, get$1, has$f;

var enforce$1 = function (it) {
  return has$f(it) ? get$1(it) : set$1(it, {});
};

var getterFor$1 = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$9(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP$1) {
  var store$4 = new WeakMap$2();
  var wmget$1 = store$4.get;
  var wmhas$1 = store$4.has;
  var wmset$1 = store$4.set;
  set$1 = function (it, metadata) {
    wmset$1.call(store$4, it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return wmget$1.call(store$4, it) || {};
  };
  has$f = function (it) {
    return wmhas$1.call(store$4, it);
  };
} else {
  var STATE$1 = sharedKey$6('state');
  hiddenKeys$6[STATE$1] = true;
  set$1 = function (it, metadata) {
    createNonEnumerableProperty$b(it, STATE$1, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return objectHas$1(it, STATE$1) ? it[STATE$1] : {};
  };
  has$f = function (it) {
    return objectHas$1(it, STATE$1);
  };
}

var internalState$1 = {
  set: set$1,
  get: get$1,
  has: has$f,
  enforce: enforce$1,
  getterFor: getterFor$1
};

var objectGetOwnPropertyDescriptor$1 = {};

var objectPropertyIsEnumerable$1 = {};

var nativePropertyIsEnumerable$1 = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG$1 = getOwnPropertyDescriptor$3 && !nativePropertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable$1.f = NASHORN_BUG$1 ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable$1;

var DESCRIPTORS$8 = descriptors$1;
var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable$1;
var createPropertyDescriptor$8 = createPropertyDescriptor$a;
var toIndexedObject$8 = toIndexedObject$9;
var toPrimitive$4 = toPrimitive$6;
var has$e = has$g;
var IE8_DOM_DEFINE$2 = ie8DomDefine$1;

var nativeGetOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor$1.f = DESCRIPTORS$8 ? nativeGetOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$8(O);
  P = toPrimitive$4(P, true);
  if (IE8_DOM_DEFINE$2) try {
    return nativeGetOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (has$e(O, P)) return createPropertyDescriptor$8(!propertyIsEnumerableModule$2.f.call(O, P), O[P]);
};

var fails$c = fails$g;

var replacement$1 = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data$1[normalize$1(feature)];
  return value == POLYFILL$1 ? true
    : value == NATIVE$1 ? false
    : typeof detection == 'function' ? fails$c(detection)
    : !!detection;
};

var normalize$1 = isForced$3.normalize = function (string) {
  return String(string).replace(replacement$1, '.').toLowerCase();
};

var data$1 = isForced$3.data = {};
var NATIVE$1 = isForced$3.NATIVE = 'N';
var POLYFILL$1 = isForced$3.POLYFILL = 'P';

var isForced_1$1 = isForced$3;

var path$8 = {};

var aFunction$5 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var aFunction$4 = aFunction$5;

// optional / simple context binding
var functionBindContext$1 = function (fn, that, length) {
  aFunction$4(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var global$d = global$j;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor$1.f;
var isForced$2 = isForced_1$1;
var path$7 = path$8;
var bind$4 = functionBindContext$1;
var createNonEnumerableProperty$a = createNonEnumerableProperty$d;
var has$d = has$g;

var wrapConstructor$1 = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export$1 = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global$d : STATIC ? global$d[TARGET] : (global$d[TARGET] || {}).prototype;

  var target = GLOBAL ? path$7 : path$7[TARGET] || (path$7[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has$d(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$2(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind$4(sourceProperty, global$d);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor$1(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind$4(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$a(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has$d(path$7, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty$a(path$7, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path$7[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty$a(targetPrototype, key, sourceProperty);
      }
    }
  }
};

var requireObjectCoercible$4 = requireObjectCoercible$6;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return Object(requireObjectCoercible$4(argument));
};

var fails$b = fails$g;

var correctPrototypeGetter$1 = !fails$b(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$c = has$g;
var toObject$4 = toObject$5;
var sharedKey$5 = sharedKey$7;
var CORRECT_PROTOTYPE_GETTER$1 = correctPrototypeGetter$1;

var IE_PROTO$3 = sharedKey$5('IE_PROTO');
var ObjectPrototype$1 = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf$1 = CORRECT_PROTOTYPE_GETTER$1 ? Object.getPrototypeOf : function (O) {
  O = toObject$4(O);
  if (has$c(O, IE_PROTO$3)) return O[IE_PROTO$3];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype$1 : null;
};

var fails$a = fails$g;

var nativeSymbol$1 = !!Object.getOwnPropertySymbols && !fails$a(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$3 = nativeSymbol$1;

var useSymbolAsUid$1 = NATIVE_SYMBOL$3
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$c = global$j;
var shared$3 = shared$5.exports;
var has$b = has$g;
var uid$3 = uid$5;
var NATIVE_SYMBOL$2 = nativeSymbol$1;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid$1;

var WellKnownSymbolsStore$1 = shared$3('wks');
var Symbol$2 = global$c.Symbol;
var createWellKnownSymbol$1 = USE_SYMBOL_AS_UID$1 ? Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$3;

var wellKnownSymbol$i = function (name) {
  if (!has$b(WellKnownSymbolsStore$1, name)) {
    if (NATIVE_SYMBOL$2 && has$b(Symbol$2, name)) WellKnownSymbolsStore$1[name] = Symbol$2[name];
    else WellKnownSymbolsStore$1[name] = createWellKnownSymbol$1('Symbol.' + name);
  } return WellKnownSymbolsStore$1[name];
};

var getPrototypeOf$3 = objectGetPrototypeOf$1;
var wellKnownSymbol$h = wellKnownSymbol$i;

wellKnownSymbol$h('iterator');
var BUGGY_SAFARI_ITERATORS$3 = false;

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$5, PrototypeOfArrayIteratorPrototype$1, arrayIterator$1;

if ([].keys) {
  arrayIterator$1 = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator$1)) BUGGY_SAFARI_ITERATORS$3 = true;
  else {
    PrototypeOfArrayIteratorPrototype$1 = getPrototypeOf$3(getPrototypeOf$3(arrayIterator$1));
    if (PrototypeOfArrayIteratorPrototype$1 !== Object.prototype) IteratorPrototype$5 = PrototypeOfArrayIteratorPrototype$1;
  }
}

if (IteratorPrototype$5 == undefined) IteratorPrototype$5 = {};

var iteratorsCore$1 = {
  IteratorPrototype: IteratorPrototype$5,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$3
};

var ceil$1 = Math.ceil;
var floor$3 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$6 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$3 : ceil$1)(argument);
};

var toInteger$5 = toInteger$6;

var min$3 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$4 = function (argument) {
  return argument > 0 ? min$3(toInteger$5(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$4 = toInteger$6;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$3 = function (index, length) {
  var integer = toInteger$4(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIndexedObject$7 = toIndexedObject$9;
var toLength$3 = toLength$4;
var toAbsoluteIndex$2 = toAbsoluteIndex$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$7($this);
    var length = toLength$3(O.length);
    var index = toAbsoluteIndex$2(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes$1 = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var has$a = has$g;
var toIndexedObject$6 = toIndexedObject$9;
var indexOf$1 = arrayIncludes$1.indexOf;
var hiddenKeys$5 = hiddenKeys$7;

var objectKeysInternal$1 = function (object, names) {
  var O = toIndexedObject$6(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$a(hiddenKeys$5, key) && has$a(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$a(O, key = names[i++])) {
    ~indexOf$1(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$5 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal$1;
var enumBugKeys$4 = enumBugKeys$5;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$4 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$4);
};

var DESCRIPTORS$7 = descriptors$1;
var definePropertyModule$3 = objectDefineProperty$1;
var anObject$c = anObject$e;
var objectKeys$3 = objectKeys$4;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties$1 = DESCRIPTORS$7 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$c(O);
  var keys = objectKeys$3(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$3.f(O, key = keys[index++], Properties[key]);
  return O;
};

var path$6 = path$8;
var global$b = global$j;

var aFunction$3 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$5 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$3(path$6[namespace]) || aFunction$3(global$b[namespace])
    : path$6[namespace] && path$6[namespace][method] || global$b[namespace] && global$b[namespace][method];
};

var getBuiltIn$4 = getBuiltIn$5;

var html$3 = getBuiltIn$4('document', 'documentElement');

var anObject$b = anObject$e;
var defineProperties$2 = objectDefineProperties$1;
var enumBugKeys$3 = enumBugKeys$5;
var hiddenKeys$4 = hiddenKeys$7;
var html$2 = html$3;
var documentCreateElement$2 = documentCreateElement$3;
var sharedKey$4 = sharedKey$7;

var GT$1 = '>';
var LT$1 = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT$1 = 'script';
var IE_PROTO$2 = sharedKey$4('IE_PROTO');

var EmptyConstructor$1 = function () { /* empty */ };

var scriptTag$1 = function (content) {
  return LT$1 + SCRIPT$1 + GT$1 + content + LT$1 + '/' + SCRIPT$1 + GT$1;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX$1 = function (activeXDocument) {
  activeXDocument.write(scriptTag$1(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame$1 = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$2('iframe');
  var JS = 'java' + SCRIPT$1 + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$2.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag$1('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument$1;
var NullProtoObject$1 = function () {
  try {
    /* global ActiveXObject */
    activeXDocument$1 = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject$1 = activeXDocument$1 ? NullProtoObjectViaActiveX$1(activeXDocument$1) : NullProtoObjectViaIFrame$1();
  var length = enumBugKeys$3.length;
  while (length--) delete NullProtoObject$1[PROTOTYPE$1][enumBugKeys$3[length]];
  return NullProtoObject$1();
};

hiddenKeys$4[IE_PROTO$2] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor$1[PROTOTYPE$1] = anObject$b(O);
    result = new EmptyConstructor$1();
    EmptyConstructor$1[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$2] = O;
  } else result = NullProtoObject$1();
  return Properties === undefined ? result : defineProperties$2(result, Properties);
};

var wellKnownSymbol$g = wellKnownSymbol$i;

var TO_STRING_TAG$5 = wellKnownSymbol$g('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$5] = 'z';

var toStringTagSupport$1 = String(test$1) === '[object z]';

var TO_STRING_TAG_SUPPORT$5 = toStringTagSupport$1;
var classofRaw$2 = classofRaw$3;
var wellKnownSymbol$f = wellKnownSymbol$i;

var TO_STRING_TAG$4 = wellKnownSymbol$f('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS$1 = classofRaw$2(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$1 = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$8 = TO_STRING_TAG_SUPPORT$5 ? classofRaw$2 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet$1(O = Object(it), TO_STRING_TAG$4)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS$1 ? classofRaw$2(O)
    // ES3 arguments fallback
    : (result = classofRaw$2(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG_SUPPORT$4 = toStringTagSupport$1;
var classof$7 = classof$8;

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString$1 = TO_STRING_TAG_SUPPORT$4 ? {}.toString : function toString() {
  return '[object ' + classof$7(this) + ']';
};

var TO_STRING_TAG_SUPPORT$3 = toStringTagSupport$1;
var defineProperty$2 = objectDefineProperty$1.f;
var createNonEnumerableProperty$9 = createNonEnumerableProperty$d;
var has$9 = has$g;
var toString$2 = objectToString$1;
var wellKnownSymbol$e = wellKnownSymbol$i;

var TO_STRING_TAG$3 = wellKnownSymbol$e('toStringTag');

var setToStringTag$8 = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has$9(target, TO_STRING_TAG$3)) {
      defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT$3) {
      createNonEnumerableProperty$9(target, 'toString', toString$2);
    }
  }
};

var IteratorPrototype$4 = iteratorsCore$1.IteratorPrototype;
var create$3 = objectCreate$1;
var createPropertyDescriptor$7 = createPropertyDescriptor$a;
var setToStringTag$7 = setToStringTag$8;
var Iterators$8 = iterators$1;

var returnThis$3 = function () { return this; };

var createIteratorConstructor$5 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$3(IteratorPrototype$4, { next: createPropertyDescriptor$7(1, next) });
  setToStringTag$7(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators$8[TO_STRING_TAG] = returnThis$3;
  return IteratorConstructor;
};

var isObject$8 = isObject$d;

var aPossiblePrototype$3 = function (it) {
  if (!isObject$8(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

var anObject$a = anObject$e;
var aPossiblePrototype$2 = aPossiblePrototype$3;

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$a(O);
    aPossiblePrototype$2(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var createNonEnumerableProperty$8 = createNonEnumerableProperty$d;

var redefine$8 = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty$8(target, key, value);
};

var $$4 = _export$1;
var createIteratorConstructor$4 = createIteratorConstructor$5;
var getPrototypeOf$2 = objectGetPrototypeOf$1;
var setToStringTag$6 = setToStringTag$8;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$d;
var redefine$7 = redefine$8;
var wellKnownSymbol$d = wellKnownSymbol$i;
var Iterators$7 = iterators$1;
var IteratorsCore$1 = iteratorsCore$1;

var IteratorPrototype$3 = IteratorsCore$1.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$2 = IteratorsCore$1.BUGGY_SAFARI_ITERATORS;
var ITERATOR$8 = wellKnownSymbol$d('iterator');
var KEYS$1 = 'keys';
var VALUES$1 = 'values';
var ENTRIES$1 = 'entries';

var returnThis$2 = function () { return this; };

var defineIterator$4 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$4(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$2 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS$1: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES$1: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES$1: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$8]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$2 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$3 !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag$6(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      Iterators$7[TO_STRING_TAG] = returnThis$2;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES$1 && nativeIterator && nativeIterator.name !== VALUES$1) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((FORCED) && IterablePrototype[ITERATOR$8] !== defaultIterator) {
    createNonEnumerableProperty$7(IterablePrototype, ITERATOR$8, defaultIterator);
  }
  Iterators$7[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES$1),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS$1),
      entries: getIterationMethod(ENTRIES$1)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$2 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$7(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$4({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$2 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject$5 = toIndexedObject$9;
var Iterators$6 = iterators$1;
var InternalStateModule$5 = internalState$1;
var defineIterator$3 = defineIterator$4;

var ARRAY_ITERATOR$1 = 'Array Iterator';
var setInternalState$5 = InternalStateModule$5.set;
var getInternalState$2 = InternalStateModule$5.getterFor(ARRAY_ITERATOR$1);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
defineIterator$3(Array, 'Array', function (iterated, kind) {
  setInternalState$5(this, {
    type: ARRAY_ITERATOR$1,
    target: toIndexedObject$5(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators$6.Arguments = Iterators$6.Array;

var fails$9 = fails$g;
var wellKnownSymbol$c = wellKnownSymbol$i;
var IS_PURE$1 = isPure$1;

var ITERATOR$7 = wellKnownSymbol$c('iterator');

var nativeUrl$1 = !fails$9(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE$1 && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$7]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var redefine$6 = redefine$8;

var redefineAll$3 = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine$6(target, key, src[key], options);
  } return target;
};

var anInstance$4 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var classof$6 = classof$8;
var Iterators$5 = iterators$1;
var wellKnownSymbol$b = wellKnownSymbol$i;

var ITERATOR$6 = wellKnownSymbol$b('iterator');

var getIteratorMethod$6 = function (it) {
  if (it != undefined) return it[ITERATOR$6]
    || it['@@iterator']
    || Iterators$5[classof$6(it)];
};

var anObject$9 = anObject$e;
var getIteratorMethod$5 = getIteratorMethod$6;

var getIterator$3 = function (it) {
  var iteratorMethod = getIteratorMethod$5(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject$9(iteratorMethod.call(it));
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$3 = _export$1;
var getBuiltIn$3 = getBuiltIn$5;
var USE_NATIVE_URL$2 = nativeUrl$1;
var redefine$5 = redefine$8;
var redefineAll$2 = redefineAll$3;
var setToStringTag$5 = setToStringTag$8;
var createIteratorConstructor$3 = createIteratorConstructor$5;
var InternalStateModule$4 = internalState$1;
var anInstance$3 = anInstance$4;
var hasOwn$1 = has$g;
var bind$3 = functionBindContext$1;
var classof$5 = classof$8;
var anObject$8 = anObject$e;
var isObject$7 = isObject$d;
var create$2 = objectCreate$1;
var createPropertyDescriptor$6 = createPropertyDescriptor$a;
var getIterator$2 = getIterator$3;
var getIteratorMethod$4 = getIteratorMethod$6;
var wellKnownSymbol$a = wellKnownSymbol$i;

var $fetch$1 = getBuiltIn$3('fetch');
var Headers$1 = getBuiltIn$3('Headers');
var ITERATOR$5 = wellKnownSymbol$a('iterator');
var URL_SEARCH_PARAMS$1 = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR$1 = URL_SEARCH_PARAMS$1 + 'Iterator';
var setInternalState$4 = InternalStateModule$4.set;
var getInternalParamsState$1 = InternalStateModule$4.getterFor(URL_SEARCH_PARAMS$1);
var getInternalIteratorState$1 = InternalStateModule$4.getterFor(URL_SEARCH_PARAMS_ITERATOR$1);

var plus$1 = /\+/g;
var sequences$1 = Array(4);

var percentSequence$1 = function (bytes) {
  return sequences$1[bytes - 1] || (sequences$1[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode$1 = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize$1 = function (it) {
  var result = it.replace(plus$1, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence$1(bytes--), percentDecode$1);
    }
    return result;
  }
};

var find$1 = /[!'()~]|%20/g;

var replace$1 = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer$1 = function (match) {
  return replace$1[match];
};

var serialize$1 = function (it) {
  return encodeURIComponent(it).replace(find$1, replacer$1);
};

var parseSearchParams$1 = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize$1(entry.shift()),
          value: deserialize$1(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams$1 = function (query) {
  this.entries.length = 0;
  parseSearchParams$1(this.entries, query);
};

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator$1 = createIteratorConstructor$3(function Iterator(params, kind) {
  setInternalState$4(this, {
    type: URL_SEARCH_PARAMS_ITERATOR$1,
    iterator: getIterator$2(getInternalParamsState$1(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState$1(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor$1 = function URLSearchParams(/* init */) {
  anInstance$3(this, URLSearchParamsConstructor$1, URL_SEARCH_PARAMS$1);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState$4(that, {
    type: URL_SEARCH_PARAMS$1,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams$1
  });

  if (init !== undefined) {
    if (isObject$7(init)) {
      iteratorMethod = getIteratorMethod$4(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator$2(anObject$8(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn$1(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams$1(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype$1 = URLSearchParamsConstructor$1.prototype;

redefineAll$2(URLSearchParamsPrototype$1, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength$1(arguments.length, 2);
    var state = getInternalParamsState$1(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState$1(this).entries;
    var boundFunction = bind$3(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator$1(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator$1(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator$1(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine$5(URLSearchParamsPrototype$1, ITERATOR$5, URLSearchParamsPrototype$1.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine$5(URLSearchParamsPrototype$1, 'toString', function toString() {
  var entries = getInternalParamsState$1(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize$1(entry.key) + '=' + serialize$1(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag$5(URLSearchParamsConstructor$1, URL_SEARCH_PARAMS$1);

$$3({ global: true, forced: !USE_NATIVE_URL$2 }, {
  URLSearchParams: URLSearchParamsConstructor$1
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL$2 && typeof $fetch$1 == 'function' && typeof Headers$1 == 'function') {
  $$3({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject$7(init)) {
          body = init.body;
          if (classof$5(body) === URL_SEARCH_PARAMS$1) {
            headers = init.headers ? new Headers$1(init.headers) : new Headers$1();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create$2(init, {
              body: createPropertyDescriptor$6(0, String(body)),
              headers: createPropertyDescriptor$6(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch$1.apply(this, args);
    }
  });
}

var web_urlSearchParams = {
  URLSearchParams: URLSearchParamsConstructor$1,
  getState: getInternalParamsState$1
};

var path$5 = path$8;

var urlSearchParams$5 = path$5.URLSearchParams;

var parent$5 = urlSearchParams$5;

var urlSearchParams$4 = parent$5;

var parent$4 = urlSearchParams$4;

var urlSearchParams$3 = parent$4;

/**
 * @internal
 */

function _removeTrailingSlash(s) {
  return s.replace(/\/+$/g, "");
}
/**
 * @internal
 */

var _BaseAPIClient = /*#__PURE__*/function () {
  function _BaseAPIClient() {}

  var _proto = _BaseAPIClient.prototype;

  _proto._prepareHeaders = /*#__PURE__*/function () {
    var _prepareHeaders2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var _this$_delegate;

      var headers, accessToken;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              headers = {};
              accessToken = (_this$_delegate = this._delegate) == null ? void 0 : _this$_delegate.getAccessToken();

              if (accessToken != null) {
                headers["authorization"] = "Bearer ".concat(accessToken);
              }

              if (this.userAgent != null) {
                headers["user-agent"] = this.userAgent;
              }

              return _context.abrupt("return", headers);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function _prepareHeaders() {
      return _prepareHeaders2.apply(this, arguments);
    }

    return _prepareHeaders;
  }();

  _proto._fetchWithoutRefresh = /*#__PURE__*/function () {
    var _fetchWithoutRefresh2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(url, init) {
      var request;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this._fetchFunction) {
                _context2.next = 2;
                break;
              }

              throw new AuthgearError("missing fetchFunction in api client");

            case 2:
              if (this._requestClass) {
                _context2.next = 4;
                break;
              }

              throw new AuthgearError("missing requestClass in api client");

            case 4:
              request = new this._requestClass(url, init);
              return _context2.abrupt("return", this._fetchFunction(request));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function _fetchWithoutRefresh(_x, _x2) {
      return _fetchWithoutRefresh2.apply(this, arguments);
    }

    return _fetchWithoutRefresh;
  }();

  _proto.fetch = /*#__PURE__*/function () {
    var _fetch = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(input, init) {
      var shouldRefresh, request, headers, _i2, _Object$keys2, key;

      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this._fetchFunction == null)) {
                _context3.next = 2;
                break;
              }

              throw new AuthgearError("missing fetchFunction in api client");

            case 2:
              if (!(this._requestClass == null)) {
                _context3.next = 4;
                break;
              }

              throw new AuthgearError("missing requestClass in api client");

            case 4:
              if (!(this._delegate == null)) {
                _context3.next = 6;
                break;
              }

              throw new AuthgearError("missing delegate in api client");

            case 6:
              shouldRefresh = this._delegate.shouldRefreshAccessToken();

              if (!shouldRefresh) {
                _context3.next = 10;
                break;
              }

              _context3.next = 10;
              return this._delegate.refreshAccessToken();

            case 10:
              request = new this._requestClass(input, init);
              _context3.next = 13;
              return this._prepareHeaders();

            case 13:
              headers = _context3.sent;

              for (_i2 = 0, _Object$keys2 = Object.keys(headers); _i2 < _Object$keys2.length; _i2++) {
                key = _Object$keys2[_i2];
                request.headers.set(key, headers[key]);
              }

              return _context3.abrupt("return", this._fetchFunction(request));

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetch(_x3, _x4) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }();

  _proto._requestJSON = /*#__PURE__*/function () {
    var _requestJSON2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(method, path, options) {
      var json, query, credentials, headers, body;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              json = options.json, query = options.query, credentials = options.credentials;
              headers = {};

              if (json != null) {
                headers["content-type"] = "application/json";
              }

              body = json != null ? JSON.stringify(json) : undefined;
              return _context4.abrupt("return", this._request(method, path, {
                headers: headers,
                query: query,
                body: body,
                credentials: credentials
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function _requestJSON(_x5, _x6, _x7) {
      return _requestJSON2.apply(this, arguments);
    }

    return _requestJSON;
  }() // eslint-disable-next-line complexity
  ;

  _proto._request =
  /*#__PURE__*/
  function () {
    var _request2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(method, path, options) {
      var endpoint, headers, query, body, credentials, p, params, i, input, response, jsonBody;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this.endpoint == null)) {
                _context5.next = 2;
                break;
              }

              throw new AuthgearError("missing endpoint in api client");

            case 2:
              endpoint = this.endpoint;
              headers = options.headers, query = options.query, body = options.body, credentials = options.credentials;
              p = path;

              if (query != null && query.length > 0) {
                params = new urlSearchParams$3();

                for (i = 0; i < query.length; ++i) {
                  params.append(query[i][0], query[i][1]);
                }

                p += "?" + params.toString();
              }

              input = endpoint + "/" + p.replace(/^\//, "");
              _context5.next = 9;
              return this.fetch(input, {
                method: method,
                headers: headers != null ? headers : {},
                mode: "cors",
                credentials: credentials,
                body: body
              });

            case 9:
              response = _context5.sent;
              _context5.prev = 10;
              _context5.next = 13;
              return response.json();

            case 13:
              jsonBody = _context5.sent;
              _context5.next = 23;
              break;

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](10);

              if (!(response.status < 200 || response.status >= 300)) {
                _context5.next = 22;
                break;
              }

              throw new ServerError("unexpected status code", "InternalError", "UnexpectedError", {
                status_code: response.status
              });

            case 22:
              throw new ServerError("failed to decode response JSON", "InternalError", "UnexpectedError");

            case 23:
              if (!jsonBody["result"]) {
                _context5.next = 27;
                break;
              }

              return _context5.abrupt("return", jsonBody["result"]);

            case 27:
              if (!jsonBody["error"]) {
                _context5.next = 29;
                break;
              }

              throw _decodeError(jsonBody["error"]);

            case 29:
              throw _decodeError(undefined);

            case 30:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[10, 16]]);
    }));

    function _request(_x8, _x9, _x10) {
      return _request2.apply(this, arguments);
    }

    return _request;
  }();

  _proto._post = /*#__PURE__*/function () {
    var _post2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(path, options) {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this._requestJSON("POST", path, options));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function _post(_x11, _x12) {
      return _post2.apply(this, arguments);
    }

    return _post;
  }();

  _proto._fetchOIDCRequest = /*#__PURE__*/function () {
    var _fetchOIDCRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(url, init) {
      var resp, errJSON;
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this._fetchWithoutRefresh(url, init);

            case 2:
              resp = _context7.sent;

              if (!(resp.status === 200)) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return", resp);

            case 5:
              _context7.prev = 5;
              _context7.next = 8;
              return resp.json();

            case 8:
              errJSON = _context7.sent;
              _context7.next = 14;
              break;

            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](5);
              throw new ServerError("failed to decode response JSON", "InternalError", "UnexpectedError", {
                status_code: resp.status
              });

            case 14:
              throw new OAuthError({
                error: errJSON["error"],
                error_description: errJSON["error_description"]
              });

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this, [[5, 11]]);
    }));

    function _fetchOIDCRequest(_x13, _x14) {
      return _fetchOIDCRequest2.apply(this, arguments);
    }

    return _fetchOIDCRequest;
  }();

  _proto._fetchOIDCJSON = /*#__PURE__*/function () {
    var _fetchOIDCJSON2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(url, init) {
      var resp, jsonBody;
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this._fetchOIDCRequest(url, init);

            case 2:
              resp = _context8.sent;
              _context8.prev = 3;
              _context8.next = 6;
              return resp.json();

            case 6:
              jsonBody = _context8.sent;
              _context8.next = 12;
              break;

            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](3);
              throw new ServerError("failed to decode response JSON", "InternalError", "UnexpectedError");

            case 12:
              return _context8.abrupt("return", jsonBody);

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[3, 9]]);
    }));

    function _fetchOIDCJSON(_x15, _x16) {
      return _fetchOIDCJSON2.apply(this, arguments);
    }

    return _fetchOIDCJSON;
  }();

  _proto._fetchOIDCConfiguration = /*#__PURE__*/function () {
    var _fetchOIDCConfiguration2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9() {
      var endpoint;
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(this.endpoint == null)) {
                _context9.next = 2;
                break;
              }

              throw new AuthgearError("missing endpoint in api client");

            case 2:
              endpoint = this.endpoint;

              if (this._config) {
                _context9.next = 7;
                break;
              }

              _context9.next = 6;
              return this._fetchOIDCJSON("".concat(endpoint, "/.well-known/openid-configuration"));

            case 6:
              this._config = _context9.sent;

            case 7:
              return _context9.abrupt("return", this._config);

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function _fetchOIDCConfiguration() {
      return _fetchOIDCConfiguration2.apply(this, arguments);
    }

    return _fetchOIDCConfiguration;
  }();

  _proto._oidcTokenRequest = /*#__PURE__*/function () {
    var _oidcTokenRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10(req) {
      var config, query, headers, credentials;
      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this._fetchOIDCConfiguration();

            case 2:
              config = _context10.sent;
              query = new urlSearchParams$3();
              query.append("grant_type", req.grant_type);
              query.append("client_id", req.client_id);

              if (req.code) {
                query.append("code", req.code);
              }

              if (req.redirect_uri) {
                query.append("redirect_uri", req.redirect_uri);
              }

              if (req.code_verifier) {
                query.append("code_verifier", req.code_verifier);
              }

              if (req.refresh_token) {
                query.append("refresh_token", req.refresh_token);
              }

              if (req.jwt) {
                query.append("jwt", req.jwt);
              }

              if (req.x_device_info) {
                query.append("x_device_info", req.x_device_info);
              }

              headers = {
                "content-type": "application/x-www-form-urlencoded"
              };
              credentials = "include";

              if (req.access_token != null) {
                headers.authorization = "Bearer ".concat(req.access_token);
                credentials = "omit";
              }

              return _context10.abrupt("return", this._fetchOIDCJSON(config.token_endpoint, {
                method: "POST",
                headers: headers,
                body: query.toString(),
                mode: "cors",
                credentials: credentials
              }));

            case 16:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function _oidcTokenRequest(_x17) {
      return _oidcTokenRequest2.apply(this, arguments);
    }

    return _oidcTokenRequest;
  }();

  _proto._setupBiometricRequest = /*#__PURE__*/function () {
    var _setupBiometricRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(req) {
      var config, headers, query;
      return regenerator.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this._fetchOIDCConfiguration();

            case 2:
              config = _context11.sent;
              headers = {
                authorization: "Bearer ".concat(req.access_token),
                "content-type": "application/x-www-form-urlencoded"
              };
              query = new urlSearchParams$3();
              query.append("grant_type", "urn:authgear:params:oauth:grant-type:biometric-request");
              query.append("client_id", req.client_id);
              query.append("jwt", req.jwt);
              _context11.next = 10;
              return this._fetchOIDCRequest(config.token_endpoint, {
                method: "POST",
                headers: headers,
                body: query.toString()
              });

            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function _setupBiometricRequest(_x18) {
      return _setupBiometricRequest2.apply(this, arguments);
    }

    return _setupBiometricRequest;
  }();

  _proto._oidcUserInfoRequest = /*#__PURE__*/function () {
    var _oidcUserInfoRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(accessToken) {
      var headers, credentials, config, response;
      return regenerator.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              headers = {};
              credentials = "include";

              if (accessToken !== undefined) {
                headers["authorization"] = "Bearer ".concat(accessToken);
                credentials = "omit";
              }

              _context12.next = 5;
              return this._fetchOIDCConfiguration();

            case 5:
              config = _context12.sent;
              _context12.next = 8;
              return this._fetchOIDCJSON(config.userinfo_endpoint, {
                method: "GET",
                headers: headers,
                mode: "cors",
                credentials: credentials
              });

            case 8:
              response = _context12.sent;
              return _context12.abrupt("return", _decodeUserInfo(response));

            case 10:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function _oidcUserInfoRequest(_x19) {
      return _oidcUserInfoRequest2.apply(this, arguments);
    }

    return _oidcUserInfoRequest;
  }();

  _proto._oidcRevocationRequest = /*#__PURE__*/function () {
    var _oidcRevocationRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13(refreshToken) {
      var config, query;
      return regenerator.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this._fetchOIDCConfiguration();

            case 2:
              config = _context13.sent;
              query = new urlSearchParams$3({
                token: refreshToken
              });
              _context13.next = 6;
              return this._fetchOIDCRequest(config.revocation_endpoint, {
                method: "POST",
                headers: {
                  "content-type": "application/x-www-form-urlencoded"
                },
                body: query.toString()
              });

            case 6:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function _oidcRevocationRequest(_x20) {
      return _oidcRevocationRequest2.apply(this, arguments);
    }

    return _oidcRevocationRequest;
  }();

  _proto._wechatAuthCallbackRequest = /*#__PURE__*/function () {
    var _wechatAuthCallbackRequest2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14(code, state, platform) {
      var query;
      return regenerator.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              query = new urlSearchParams$3({
                code: code,
                state: state,
                x_platform: platform
              });
              _context14.next = 3;
              return this._request("POST", "/sso/wechat/callback", {
                credentials: "omit",
                headers: {
                  "content-type": "application/x-www-form-urlencoded"
                },
                body: query.toString()
              });

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function _wechatAuthCallbackRequest(_x21, _x22, _x23) {
      return _wechatAuthCallbackRequest2.apply(this, arguments);
    }

    return _wechatAuthCallbackRequest;
  }();

  _proto.appSessionToken = /*#__PURE__*/function () {
    var _appSessionToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee15(refreshToken) {
      return regenerator.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this._post("/oauth2/app_session_token", {
                credentials: "omit",
                json: {
                  refresh_token: refreshToken
                }
              }));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function appSessionToken(_x24) {
      return _appSessionToken.apply(this, arguments);
    }

    return appSessionToken;
  }();

  _proto.oauthChallenge = /*#__PURE__*/function () {
    var _oauthChallenge = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee16(purpose) {
      return regenerator.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this._post("/oauth2/challenge", {
                credentials: "omit",
                json: {
                  purpose: purpose
                }
              }));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function oauthChallenge(_x25) {
      return _oauthChallenge.apply(this, arguments);
    }

    return oauthChallenge;
  }();

  _proto.signupAnonymousUserWithoutKey = /*#__PURE__*/function () {
    var _signupAnonymousUserWithoutKey = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee17(clientID, sessionType, refreshToken) {
      var payload, result;
      return regenerator.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              payload = {
                client_id: clientID,
                session_type: sessionType
              };

              if (refreshToken) {
                payload["refresh_token"] = refreshToken;
              }

              _context17.next = 4;
              return this._post("/api/anonymous_user/signup", {
                json: payload,
                credentials: sessionType === "cookie" ? "include" : "omit"
              });

            case 4:
              result = _context17.sent;

              if (!(Object.keys(result).length === 0)) {
                _context17.next = 7;
                break;
              }

              return _context17.abrupt("return", undefined);

            case 7:
              return _context17.abrupt("return", result);

            case 8:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function signupAnonymousUserWithoutKey(_x26, _x27, _x28) {
      return _signupAnonymousUserWithoutKey.apply(this, arguments);
    }

    return signupAnonymousUserWithoutKey;
  }();

  _proto.anonymousUserPromotionCode = /*#__PURE__*/function () {
    var _anonymousUserPromotionCode = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee18(sessionType, refreshToken) {
      var payload;
      return regenerator.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              payload = {
                session_type: sessionType
              };

              if (refreshToken) {
                payload["refresh_token"] = refreshToken;
              }

              return _context18.abrupt("return", this._post("/api/anonymous_user/promotion_code", {
                json: payload,
                credentials: sessionType === "cookie" ? "include" : "omit"
              }));

            case 3:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    function anonymousUserPromotionCode(_x29, _x30) {
      return _anonymousUserPromotionCode.apply(this, arguments);
    }

    return anonymousUserPromotionCode;
  }();

  _createClass(_BaseAPIClient, [{
    key: "endpoint",
    get: function get() {
      return this._endpoint;
    },
    set: function set(newEndpoint) {
      if (newEndpoint != null) {
        this._endpoint = _removeTrailingSlash(newEndpoint);
      } else {
        this._endpoint = undefined;
      }
    } // eslint-disable-next-line no-undef

  }]);

  return _BaseAPIClient;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var toInteger$3 = toInteger$6;
var requireObjectCoercible$3 = requireObjectCoercible$6;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$3($this));
    var position = toInteger$3(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt = stringMultibyte.charAt;
var InternalStateModule$3 = internalState$1;
var defineIterator$2 = defineIterator$4;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = InternalStateModule$3.set;
var getInternalState$1 = InternalStateModule$3.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator$2(String, 'String', function (iterated) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var DESCRIPTORS$6 = descriptors$1;
var fails$8 = fails$g;
var objectKeys$2 = objectKeys$4;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable$1;
var toObject$3 = toObject$5;
var IndexedObject$1 = indexedObject$1;

var nativeAssign = Object.assign;
var defineProperty$1 = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails$8(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$6 && nativeAssign({ b: 1 }, nativeAssign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys$2(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule$1.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$2(S).concat(getOwnPropertySymbols(S)) : objectKeys$2(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$6 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var anObject$7 = anObject$e;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$7(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject$7(returnMethod.call(iterator));
    throw error;
  }
};

var wellKnownSymbol$9 = wellKnownSymbol$i;
var Iterators$4 = iterators$1;

var ITERATOR$4 = wellKnownSymbol$9('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype[ITERATOR$4] === it);
};

var toPrimitive$3 = toPrimitive$6;
var definePropertyModule$2 = objectDefineProperty$1;
var createPropertyDescriptor$5 = createPropertyDescriptor$a;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPrimitive$3(key);
  if (propertyKey in object) definePropertyModule$2.f(object, propertyKey, createPropertyDescriptor$5(0, value));
  else object[propertyKey] = value;
};

var bind$2 = functionBindContext$1;
var toObject$2 = toObject$5;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var toLength$2 = toLength$4;
var createProperty = createProperty$1;
var getIteratorMethod$3 = getIteratorMethod$6;

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$2(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod$3(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind$2(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength$2(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor$2 = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$2(delta / damp) : delta >> 1;
  delta += floor$2(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor$2(delta / baseMinusTMin);
  }
  return floor$2(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line  max-statements
var encode$1 = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$2((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$2(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode$1(label) : label);
  }
  return encoded.join('.');
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$2 = _export$1;
var DESCRIPTORS$5 = descriptors$1;
var USE_NATIVE_URL$1 = nativeUrl$1;
var global$a = global$j;
var defineProperties$1 = objectDefineProperties$1;
var redefine$4 = redefine$8;
var anInstance$2 = anInstance$4;
var has$8 = has$g;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var setToStringTag$4 = setToStringTag$8;
var URLSearchParamsModule = web_urlSearchParams;
var InternalStateModule$2 = internalState$1;

var NativeURL = global$a.URL;
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState$2 = InternalStateModule$2.set;
var getInternalURLState = InternalStateModule$2.getterFor('URL');
var floor$1 = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
// eslint-disable-next-line no-control-regex
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
// eslint-disable-next-line no-control-regex
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor$1(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has$8(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has$8(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has$8(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance$2(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState$2(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams$1();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS$5) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS$5) {
  defineProperties$1(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine$4(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine$4(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeCreateObjectURL) redefine$4(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars
  if (nativeRevokeObjectURL) redefine$4(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag$4(URLConstructor, 'URL');

$$2({ global: true, forced: !USE_NATIVE_URL$1, sham: !DESCRIPTORS$5 }, {
  URL: URLConstructor
});

var path$4 = path$8;

var url$2 = path$4.URL;

var parent$3 = url$2;

var url$1 = parent$3;

var parent$2 = url$1;

var url = parent$2;

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

var decode;
var encode;
(function(){

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  decode = function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();

/**
 * @internal
 */

function _base64URLEncode(arrayBuffer) {
  return encode(arrayBuffer).replace(/\//g, "_").replace(/\+/g, "-").replace(/=+$/, "");
}
/**
 * @internal
 */

function _base64URLDecode(s) {
  // base64-arraybuffer ignores padding actually.
  // https://github.com/niklasvh/base64-arraybuffer/blob/master/lib/base64-arraybuffer.js#L44
  // so we need not bother with adding padding to the encoded string.
  return decode(s.replace(/-/g, "+").replace(/_/g, "/"));
}

var textEncodingShim = {exports: {}};

(function (module, exports) {
(function (root, factory) {
    {
        module.exports = factory();
    }
}(commonjsGlobal, function () {
	// return native implementation if available
	var g = typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : self;
	if (typeof g.TextEncoder !== 'undefined' && typeof g.TextDecoder !== 'undefined') {
		return {'TextEncoder': g.TextEncoder, 'TextDecoder': g.TextDecoder};
	}

	// allowed encoding strings for utf-8
	var utf8Encodings = [
		'utf8',
		'utf-8',
		'unicode-1-1-utf-8'
	];

	var TextEncoder = function(encoding) {
		if (utf8Encodings.indexOf(encoding) < 0 && typeof encoding !== 'undefined' && encoding !== null) {
			throw new RangeError('Invalid encoding type. Only utf-8 is supported');
		} else {
			this.encoding = 'utf-8';
			this.encode = function(str) {
				if (typeof str !== 'string') {
					throw new TypeError('passed argument must be of type string');
				}
				var binstr = unescape(encodeURIComponent(str)),
					arr = new Uint8Array(binstr.length);
				binstr.split('').forEach(function(char, i) {
					arr[i] = char.charCodeAt(0);
				});
				return arr;
			};
		}
	};

	var TextDecoder = function(encoding, options) {
		if (utf8Encodings.indexOf(encoding) < 0 && typeof encoding !== 'undefined' && encoding !== null) {
			throw new RangeError('Invalid encoding type. Only utf-8 is supported');
		}
		this.encoding = 'utf-8';
		this.ignoreBOM = false;
		this.fatal = (typeof options !== 'undefined' && 'fatal' in options) ? options.fatal : false;
		if (typeof this.fatal !== 'boolean') {
			throw new TypeError('fatal flag must be boolean');
		}
		this.decode = function (view, options) {
			if (typeof view === 'undefined') {
				return '';
			}

			var stream = (typeof options !== 'undefined' && 'stream' in options) ? options.stream : false;
			if (typeof stream !== 'boolean') {
				throw new TypeError('stream option must be boolean');
			}

			if (!ArrayBuffer.isView(view)) {
				throw new TypeError('passed argument must be an array buffer view');
			} else {
				var arr = new Uint8Array(view.buffer, view.byteOffset, view.byteLength),
					charArr = new Array(arr.length);
				arr.forEach(function(charcode, i) {
					charArr[i] = String.fromCharCode(charcode);
				});
				return decodeURIComponent(escape(charArr.join('')));
			}
		};
	};
	return {'TextEncoder': TextEncoder, 'TextDecoder': TextDecoder};
}));
}(textEncodingShim));

/**
 * @internal
 */

function _encodeUTF8(input) {
  return new textEncodingShim.exports.TextEncoder().encode(input);
}
/**
 * @internal
 */

function _decodeUTF8(input) {
  return new textEncodingShim.exports.TextDecoder().decode(input);
}

/**
 * To prevent user from using expired access token, we have to check in advance
 * whether it had expired in `shouldRefreshAccessToke`. If we
 * use the expiry time in {@link _OIDCTokenResponse} directly to check for expiry, it is possible
 * that the access token had passed the check but ends up being expired when it arrives at
 * the server due to slow traffic or unfair scheduler.
 *
 * To compat this, we should consider the access token expired earlier than the expiry time
 * calculated using {@link _OIDCTokenResponse.expires_in}. Current implementation uses
 * {@link EXPIRE_IN_PERCENTAGE} of {@link _OIDCTokenResponse.expires_in} to calculate the expiry time.
 *
 * @internal
 */
var EXPIRE_IN_PERCENTAGE = 0.9;
/**
 * @internal
 */

/**
 * @internal
 */
function _decodeIDToken(idToken) {
  // idToken is the format
  // base64URLEncode(header) "." base64URLEncode(payload) "." signature
  if (idToken == null) {
    return undefined;
  }

  var parts = idToken.split(".");

  if (parts.length !== 3) {
    return undefined;
  }

  var payload = parts[1];

  var utf8Bytes = _base64URLDecode(payload);

  var utf8Str = _decodeUTF8(new Uint8Array(utf8Bytes));

  var idTokenPayload = JSON.parse(utf8Str);
  return idTokenPayload;
}
/**
 * @internal
 */

function _canReauthenticate(idTokenPayload) {
  var can = idTokenPayload["https://authgear.com/claims/user/can_reauthenticate"];

  if (typeof can === "boolean") {
    return can;
  }

  return false;
}
/**
 * @internal
 */

function _getAuthTime(idTokenPayload) {
  var authTimeValue = idTokenPayload["auth_time"];

  if (typeof authTimeValue === "number") {
    // authTimeValue is Unix epoch while JavaScript Date constructor accepts milliseconds.
    return new Date(authTimeValue * 1000);
  }

  return undefined;
}
/**
 * Base Container
 *
 * @internal
 */

var _BaseContainer = /*#__PURE__*/function () {
  function _BaseContainer(options, apiClient, _delegate) {
    var _options$name;

    this.name = (_options$name = options.name) != null ? _options$name : "default";
    this.apiClient = apiClient;
    this.sessionState = "UNKNOWN";
    this._delegate = _delegate;
  }

  var _proto = _BaseContainer.prototype;

  _proto.getIDTokenHint = function getIDTokenHint() {
    return this.idToken;
  };

  _proto.canReauthenticate = function canReauthenticate() {
    var payload = _decodeIDToken(this.idToken);

    if (payload == null) {
      return false;
    }

    return _canReauthenticate(payload);
  };

  _proto.getAuthTime = function getAuthTime() {
    var payload = _decodeIDToken(this.idToken);

    if (payload == null) {
      return undefined;
    }

    return _getAuthTime(payload);
  };

  _proto._persistTokenResponse = /*#__PURE__*/function () {
    var _persistTokenResponse2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(response, reason) {
      var id_token, access_token, refresh_token, expires_in;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id_token = response.id_token, access_token = response.access_token, refresh_token = response.refresh_token, expires_in = response.expires_in;

              if (!(access_token == null || expires_in == null)) {
                _context.next = 3;
                break;
              }

              throw new AuthgearError("access_token or expires_in missing in Token Response");

            case 3:
              if (id_token != null) {
                this.idToken = id_token;
              }

              this.accessToken = access_token;

              if (refresh_token) {
                this.refreshToken = refresh_token;
              }

              this.expireAt = new Date(new Date(Date.now()).getTime() + expires_in * EXPIRE_IN_PERCENTAGE * 1000);

              this._updateSessionState("AUTHENTICATED", reason);

              if (!refresh_token) {
                _context.next = 11;
                break;
              }

              _context.next = 11;
              return this._delegate.tokenStorage.setRefreshToken(this.name, refresh_token);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function _persistTokenResponse(_x, _x2) {
      return _persistTokenResponse2.apply(this, arguments);
    }

    return _persistTokenResponse;
  }();

  _proto._clearSession = /*#__PURE__*/function () {
    var _clearSession2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(reason) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._delegate.tokenStorage.delRefreshToken(this.name);

            case 2:
              this.idToken = undefined;
              this.accessToken = undefined;
              this.refreshToken = undefined;
              this.expireAt = undefined;

              this._updateSessionState("NO_SESSION", reason);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function _clearSession(_x3) {
      return _clearSession2.apply(this, arguments);
    }

    return _clearSession;
  }();

  _proto.refreshAccessTokenIfNeeded = /*#__PURE__*/function () {
    var _refreshAccessTokenIfNeeded = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.shouldRefreshAccessToken()) {
                _context3.next = 3;
                break;
              }

              _context3.next = 3;
              return this._delegate.refreshAccessToken();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function refreshAccessTokenIfNeeded() {
      return _refreshAccessTokenIfNeeded.apply(this, arguments);
    }

    return refreshAccessTokenIfNeeded;
  }();

  _proto.clearSessionState = /*#__PURE__*/function () {
    var _clearSessionState = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this._clearSession("CLEAR");

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function clearSessionState() {
      return _clearSessionState.apply(this, arguments);
    }

    return clearSessionState;
  }();

  _proto.shouldRefreshAccessToken = function shouldRefreshAccessToken() {
    // No need to refresh if we do not even have a refresh token.
    if (this.refreshToken == null) {
      return false;
    } // When we have a refresh token but not an access token


    if (this.accessToken == null) {
      return true;
    } // When we have a refresh token and an access token but its expiration is unknown.


    if (this.expireAt == null) {
      return true;
    } // When we have a refresh token and an access token but it is indeed expired.


    var now = new Date(Date.now());

    if (this.expireAt.getTime() < now.getTime()) {
      return true;
    } // Otherwise no need to refresh.


    return false;
  };

  _proto.fetch = /*#__PURE__*/function () {
    var _fetch = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(input, init) {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.apiClient.fetch(input, init));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function fetch(_x4, _x5) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }();

  _proto._refreshAccessToken = /*#__PURE__*/function () {
    var _refreshAccessToken2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(tokenRequest) {
      var clientID, refreshToken, tokenResponse;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              // If token request fails due to other reasons, session will be kept and
              // the whole process can be retried.
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context6.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              _context6.next = 5;
              return this._delegate.tokenStorage.getRefreshToken(this.name);

            case 5:
              refreshToken = _context6.sent;

              if (!(refreshToken == null)) {
                _context6.next = 10;
                break;
              }

              _context6.next = 9;
              return this._clearSession("NO_TOKEN");

            case 9:
              return _context6.abrupt("return");

            case 10:
              _context6.prev = 10;
              _context6.next = 13;
              return this.apiClient._oidcTokenRequest(_extends({}, tokenRequest, {
                grant_type: "refresh_token",
                client_id: clientID,
                refresh_token: refreshToken
              }));

            case 13:
              tokenResponse = _context6.sent;
              _context6.next = 23;
              break;

            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](10);

              if (!(_context6.t0 != null && _context6.t0.error === "invalid_grant")) {
                _context6.next = 22;
                break;
              }

              _context6.next = 21;
              return this._clearSession("INVALID");

            case 21:
              return _context6.abrupt("return");

            case 22:
              throw _context6.t0;

            case 23:
              _context6.next = 25;
              return this._persistTokenResponse(tokenResponse, "FOUND_TOKEN");

            case 25:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[10, 16]]);
    }));

    function _refreshAccessToken(_x6) {
      return _refreshAccessToken2.apply(this, arguments);
    }

    return _refreshAccessToken;
  }();

  _proto.refreshIDToken = /*#__PURE__*/function () {
    var _refreshIDToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
      var clientID, accessToken, tokenRequest, _yield$this$apiClient, id_token;

      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context7.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              _context7.next = 5;
              return this.refreshAccessTokenIfNeeded();

            case 5:
              accessToken = this.accessToken;
              tokenRequest = {
                grant_type: "urn:authgear:params:oauth:grant-type:id-token",
                client_id: clientID,
                access_token: accessToken
              };
              _context7.next = 9;
              return this.apiClient._oidcTokenRequest(tokenRequest);

            case 9:
              _yield$this$apiClient = _context7.sent;
              id_token = _yield$this$apiClient.id_token;

              if (id_token != null) {
                this.idToken = id_token;
              }

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function refreshIDToken() {
      return _refreshIDToken.apply(this, arguments);
    }

    return refreshIDToken;
  }() // eslint-disable-next-line complexity
  ;

  _proto.authorizeEndpoint =
  /*#__PURE__*/
  function () {
    var _authorizeEndpoint = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(options) {
      var clientID, config, query, responseType, codeVerifier;
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context8.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              _context8.next = 5;
              return this.apiClient._fetchOIDCConfiguration();

            case 5:
              config = _context8.sent;
              query = new urlSearchParams$3();
              responseType = options.responseType;
              query.append("response_type", responseType);

              if (!(responseType === "code")) {
                _context8.next = 17;
                break;
              }

              _context8.next = 12;
              return this._delegate._setupCodeVerifier();

            case 12:
              codeVerifier = _context8.sent;
              _context8.next = 15;
              return this._delegate.storage.setOIDCCodeVerifier(this.name, codeVerifier.verifier);

            case 15:
              query.append("code_challenge_method", "S256");
              query.append("code_challenge", codeVerifier.challenge);

            case 17:
              query.append("scope", options.scope.join(" "));
              query.append("client_id", clientID);
              query.append("redirect_uri", options.redirectURI);

              if (options.state != null) {
                query.append("state", options.state);
              }

              if (options.prompt != null) {
                if (typeof options.prompt === "string") {
                  query.append("prompt", options.prompt);
                } else if (options.prompt.length > 0) {
                  query.append("prompt", options.prompt.join(" "));
                }
              }

              if (options.loginHint != null) {
                query.append("login_hint", options.loginHint);
              }

              if (options.uiLocales != null) {
                query.append("ui_locales", options.uiLocales.join(" "));
              }

              if (options.colorScheme != null) {
                query.append("x_color_scheme", options.colorScheme);
              }

              if (options.idTokenHint != null) {
                query.append("id_token_hint", options.idTokenHint);
              }

              if (options.maxAge != null) {
                query.append("max_age", String(options.maxAge));
              }

              if (options.wechatRedirectURI != null) {
                query.append("x_wechat_redirect_uri", options.wechatRedirectURI);
              }

              if (options.platform != null) {
                query.append("x_platform", options.platform);
              }

              if (options.page != null) {
                query.append("x_page", options.page);
              }

              if (options.suppressIDPSessionCookie === true) {
                query.append("x_suppress_idp_session_cookie", "true");
              }

              if (options.oauthProviderAlias != null) {
                query.append("x_oauth_provider_alias", options.oauthProviderAlias);
              }

              return _context8.abrupt("return", "".concat(config.authorization_endpoint, "?").concat(query.toString()));

            case 33:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function authorizeEndpoint(_x7) {
      return _authorizeEndpoint.apply(this, arguments);
    }

    return authorizeEndpoint;
  }();

  _proto._finishAuthentication = /*#__PURE__*/function () {
    var _finishAuthentication2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(url$1, tokenRequest) {
      var _params$get2;

      var clientID, u, params, uu, redirectURI, _params$get, userInfo, tokenResponse, code, codeVerifier;

      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context9.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              u = new url(url$1);
              params = u.searchParams;
              uu = new url(url$1);
              uu.hash = "";
              uu.search = "";
              redirectURI = uu.toString();

              if (!params.get("error")) {
                _context9.next = 11;
                break;
              }

              throw new OAuthError({
                error: params.get("error"),
                error_description: (_params$get = params.get("error_description")) != null ? _params$get : undefined
              });

            case 11:
              if (params.has("code")) {
                _context9.next = 17;
                break;
              }

              _context9.next = 14;
              return this.apiClient._oidcUserInfoRequest();

            case 14:
              userInfo = _context9.sent;
              _context9.next = 29;
              break;

            case 17:
              code = params.get("code");

              if (code) {
                _context9.next = 20;
                break;
              }

              throw new OAuthError({
                error: "invalid_request",
                error_description: "Missing parameter: code"
              });

            case 20:
              _context9.next = 22;
              return this._delegate.storage.getOIDCCodeVerifier(this.name);

            case 22:
              codeVerifier = _context9.sent;
              _context9.next = 25;
              return this.apiClient._oidcTokenRequest(_extends({}, tokenRequest, {
                grant_type: "authorization_code",
                code: code,
                redirect_uri: redirectURI,
                client_id: clientID,
                code_verifier: codeVerifier != null ? codeVerifier : ""
              }));

            case 25:
              tokenResponse = _context9.sent;
              _context9.next = 28;
              return this.apiClient._oidcUserInfoRequest(tokenResponse.access_token);

            case 28:
              userInfo = _context9.sent;

            case 29:
              if (!tokenResponse) {
                _context9.next = 32;
                break;
              }

              _context9.next = 32;
              return this._persistTokenResponse(tokenResponse, "AUTHENTICATED");

            case 32:
              return _context9.abrupt("return", {
                userInfo: userInfo,
                state: (_params$get2 = params.get("state")) != null ? _params$get2 : undefined
              });

            case 33:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function _finishAuthentication(_x8, _x9) {
      return _finishAuthentication2.apply(this, arguments);
    }

    return _finishAuthentication;
  }();

  _proto._finishReauthentication = /*#__PURE__*/function () {
    var _finishReauthentication2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10(url$1, tokenRequest) {
      var _params$get4;

      var clientID, u, params, uu, redirectURI, _params$get3, code, codeVerifier, _yield$this$apiClient2, id_token, access_token, userInfo;

      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context10.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              u = new url(url$1);
              params = u.searchParams;
              uu = new url(url$1);
              uu.hash = "";
              uu.search = "";
              redirectURI = uu.toString();

              if (!params.get("error")) {
                _context10.next = 11;
                break;
              }

              throw new OAuthError({
                error: params.get("error"),
                error_description: (_params$get3 = params.get("error_description")) != null ? _params$get3 : undefined
              });

            case 11:
              code = params.get("code");

              if (code) {
                _context10.next = 14;
                break;
              }

              throw new OAuthError({
                error: "invalid_request",
                error_description: "Missing parameter: code"
              });

            case 14:
              _context10.next = 16;
              return this._delegate.storage.getOIDCCodeVerifier(this.name);

            case 16:
              codeVerifier = _context10.sent;
              _context10.next = 19;
              return this.apiClient._oidcTokenRequest(_extends({}, tokenRequest, {
                grant_type: "authorization_code",
                code: code,
                redirect_uri: redirectURI,
                client_id: clientID,
                code_verifier: codeVerifier != null ? codeVerifier : ""
              }));

            case 19:
              _yield$this$apiClient2 = _context10.sent;
              id_token = _yield$this$apiClient2.id_token;
              access_token = _yield$this$apiClient2.access_token;
              _context10.next = 24;
              return this.apiClient._oidcUserInfoRequest(access_token);

            case 24:
              userInfo = _context10.sent;

              if (id_token != null) {
                this.idToken = id_token;
              }

              return _context10.abrupt("return", {
                userInfo: userInfo,
                state: (_params$get4 = params.get("state")) != null ? _params$get4 : undefined
              });

            case 27:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function _finishReauthentication(_x10, _x11) {
      return _finishReauthentication2.apply(this, arguments);
    }

    return _finishReauthentication;
  }()
  /**
   * Update session state.
   */
  ;

  _proto._updateSessionState = function _updateSessionState(state, reason) {
    this.sessionState = state;

    this._delegate.onSessionStateChange(reason);
  };

  return _createClass(_BaseContainer);
}();

/**
 * @internal
 */
var _KeyMaker = /*#__PURE__*/function () {
  function _KeyMaker() {}

  var _proto = _KeyMaker.prototype;

  // eslint-disable-next-line class-methods-use-this
  _proto.scopedKey = function scopedKey(key) {
    return "authgear_".concat(key);
  };

  _proto.keyRefreshToken = function keyRefreshToken(name) {
    return "".concat(this.scopedKey(name), "_refreshToken");
  };

  _proto.keyOIDCCodeVerifier = function keyOIDCCodeVerifier(name) {
    return "".concat(this.scopedKey(name), "_oidcCodeVerifier");
  };

  _proto.keyAnonymousKeyID = function keyAnonymousKeyID(name) {
    return "".concat(this.scopedKey(name), "_anonymousKeyID");
  };

  _proto.keyBiometricKeyID = function keyBiometricKeyID(name) {
    return "".concat(this.scopedKey(name), "_biometricKeyID");
  };

  return _createClass(_KeyMaker);
}();
/**
 * @internal
 */

var _SafeStorageDriver = /*#__PURE__*/function () {
  function _SafeStorageDriver(driver) {
    this.driver = driver;
  }

  var _proto2 = _SafeStorageDriver.prototype;

  _proto2.del = /*#__PURE__*/function () {
    var _del = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(key) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.driver.del(key);

            case 3:
              _context.next = 7;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 5]]);
    }));

    function del(_x) {
      return _del.apply(this, arguments);
    }

    return del;
  }();

  _proto2.get = /*#__PURE__*/function () {
    var _get = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(key) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.driver.get(key);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", null);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 6]]);
    }));

    function get(_x2) {
      return _get.apply(this, arguments);
    }

    return get;
  }();

  _proto2.set = /*#__PURE__*/function () {
    var _set = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(key, value) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.driver.set(key, value);

            case 3:
              _context3.next = 7;
              break;

            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](0);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 5]]);
    }));

    function set(_x3, _x4) {
      return _set.apply(this, arguments);
    }

    return set;
  }();

  return _createClass(_SafeStorageDriver);
}();
/**
 * @internal
 */

var _MemoryStorageDriver = /*#__PURE__*/function () {
  function _MemoryStorageDriver() {
    this.backingStore = {};
  }

  var _proto3 = _MemoryStorageDriver.prototype;

  _proto3.get = /*#__PURE__*/function () {
    var _get2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(key) {
      var value;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              value = this.backingStore[key];

              if (!(value != null)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return", value);

            case 3:
              return _context4.abrupt("return", null);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function get(_x5) {
      return _get2.apply(this, arguments);
    }

    return get;
  }();

  _proto3.set = /*#__PURE__*/function () {
    var _set2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(key, value) {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              this.backingStore[key] = value;

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function set(_x6, _x7) {
      return _set2.apply(this, arguments);
    }

    return set;
  }();

  _proto3.del = /*#__PURE__*/function () {
    var _del2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(key) {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              delete this.backingStore[key];

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function del(_x8) {
      return _del2.apply(this, arguments);
    }

    return del;
  }();

  return _createClass(_MemoryStorageDriver);
}();
/**
 * @public
 */

var TransientTokenStorage = /*#__PURE__*/function () {
  function TransientTokenStorage() {
    this.keyMaker = new _KeyMaker();
    this.storageDriver = new _SafeStorageDriver(new _MemoryStorageDriver());
  }

  var _proto4 = TransientTokenStorage.prototype;

  _proto4.setRefreshToken = /*#__PURE__*/function () {
    var _setRefreshToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(namespace, refreshToken) {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.storageDriver.set(this.keyMaker.keyRefreshToken(namespace), refreshToken);

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function setRefreshToken(_x9, _x10) {
      return _setRefreshToken.apply(this, arguments);
    }

    return setRefreshToken;
  }();

  _proto4.getRefreshToken = /*#__PURE__*/function () {
    var _getRefreshToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(namespace) {
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.storageDriver.get(this.keyMaker.keyRefreshToken(namespace)));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getRefreshToken(_x11) {
      return _getRefreshToken.apply(this, arguments);
    }

    return getRefreshToken;
  }();

  _proto4.delRefreshToken = /*#__PURE__*/function () {
    var _delRefreshToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(namespace) {
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.storageDriver.del(this.keyMaker.keyRefreshToken(namespace));

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function delRefreshToken(_x12) {
      return _delRefreshToken.apply(this, arguments);
    }

    return delRefreshToken;
  }();

  return _createClass(TransientTokenStorage);
}();

var _;
/**
 * @public
 */

var VERSION = (_ = "1.0.1") != null ? _ : "VERSION";

var fails$7 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString$1 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$1.call(it).slice(8, -1);
};

var fails$6 = fails$7;
var classof$4 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$4 = function (it) {
  return IndexedObject(requireObjectCoercible$1(it));
};

var iterators = {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$9 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails$5 = fails$7;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$5(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectDefineProperty = {};

var isObject$6 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var global$8 = global$9;
var isObject$5 = isObject$6;

var document$1 = global$8.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$5(document$1) && isObject$5(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

var DESCRIPTORS$4 = descriptors;
var fails$4 = fails$7;
var createElement = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$4 && !fails$4(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var isObject$4 = isObject$6;

var anObject$6 = function (it) {
  if (!isObject$4(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var isObject$3 = isObject$6;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$3(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$3(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$3(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$3(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var DESCRIPTORS$3 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var anObject$5 = anObject$6;
var toPrimitive$1 = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$3 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$5(O);
  P = toPrimitive$1(P, true);
  anObject$5(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;

var createNonEnumerableProperty$6 = DESCRIPTORS$2 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var global$7 = global$9;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;

var setGlobal$1 = function (key, value) {
  try {
    createNonEnumerableProperty$5(global$7, key, value);
  } catch (error) {
    global$7[key] = value;
  } return value;
};

var global$6 = global$9;
var setGlobal = setGlobal$1;

var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || setGlobal(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$1 = store$2.inspectSource;

var global$5 = global$9;
var inspectSource = inspectSource$1;

var WeakMap$1 = global$5.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource(WeakMap$1));

var hasOwnProperty = {}.hasOwnProperty;

var has$7 = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var shared$2 = {exports: {}};

var isPure = true;

var store$1 = sharedStore;

(shared$2.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: 'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared$1 = shared$2.exports;
var uid$1 = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$4 = global$9;
var isObject$2 = isObject$6;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var objectHas = has$7;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$2 = hiddenKeys$3;

var WeakMap = global$4.WeakMap;
var set, get, has$6;

var enforce = function (it) {
  return has$6(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$6 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$6 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$6,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var DESCRIPTORS$1 = descriptors;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;
var toIndexedObject$3 = toIndexedObject$4;
var toPrimitive = toPrimitive$2;
var has$5 = has$7;
var IE8_DOM_DEFINE = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$1 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$5(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};

var fails$3 = fails$7;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$3(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var path$3 = {};

var aFunction$2 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var aFunction$1 = aFunction$2;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var global$3 = global$9;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var isForced = isForced_1;
var path$2 = path$3;
var bind$1 = functionBindContext;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;
var has$4 = has$7;

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global$3 : STATIC ? global$3[TARGET] : (global$3[TARGET] || {}).prototype;

  var target = GLOBAL ? path$2 : path$2[TARGET] || (path$2[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has$4(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind$1(sourceProperty, global$3);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind$1(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has$4(path$2, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty$3(path$2, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path$2[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty$3(targetPrototype, key, sourceProperty);
      }
    }
  }
};

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var fails$2 = fails$7;

var correctPrototypeGetter = !fails$2(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$3 = has$7;
var toObject = toObject$1;
var sharedKey$1 = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO$1 = sharedKey$1('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has$3(O, IE_PROTO$1)) return O[IE_PROTO$1];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var fails$1 = fails$7;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$1(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$2 = global$9;
var shared = shared$2.exports;
var has$2 = has$7;
var uid = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global$2.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol$8 = function (name) {
  if (!has$2(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has$2(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var getPrototypeOf$1 = objectGetPrototypeOf;
var wellKnownSymbol$7 = wellKnownSymbol$8;

wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype$2 == undefined) IteratorPrototype$2 = {};

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength = toLength$1;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var has$1 = has$7;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS = descriptors;
var definePropertyModule = objectDefineProperty;
var anObject$4 = anObject$6;
var objectKeys = objectKeys$1;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$4(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};

var path$1 = path$3;
var global$1 = global$9;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$2 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path$1[namespace]) || aFunction(global$1[namespace])
    : path$1[namespace] && path$1[namespace][method] || global$1[namespace] && global$1[namespace][method];
};

var getBuiltIn$1 = getBuiltIn$2;

var html$1 = getBuiltIn$1('document', 'documentElement');

var anObject$3 = anObject$6;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$2;
var hiddenKeys = hiddenKeys$3;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$3(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$6 = wellKnownSymbol$8;

var TO_STRING_TAG$2 = wellKnownSymbol$6('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$5 = wellKnownSymbol$8;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$3 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$2 = classof$3;

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$2(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineProperty = objectDefineProperty.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var has = has$7;
var toString = objectToString;
var wellKnownSymbol$4 = wellKnownSymbol$8;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');

var setToStringTag$3 = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty$2(target, 'toString', toString);
    }
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$2 = setToStringTag$3;
var Iterators$3 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor$1(1, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators$3[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isObject$1 = isObject$6;

var aPossiblePrototype$1 = function (it) {
  if (!isObject$1(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

var anObject$2 = anObject$6;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$2(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;

var redefine$3 = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty$1(target, key, value);
};

var $$1 = _export;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf = objectGetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty = createNonEnumerableProperty$6;
var redefine$2 = redefine$3;
var wellKnownSymbol$3 = wellKnownSymbol$8;
var Iterators$2 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$3('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      Iterators$2[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((FORCED) && IterablePrototype[ITERATOR$3] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$3, defaultIterator);
  }
  Iterators$2[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$1({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject = toIndexedObject$4;
var Iterators$1 = iterators;
var InternalStateModule$1 = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators$1.Arguments = Iterators$1.Array;

var fails = fails$7;
var wellKnownSymbol$2 = wellKnownSymbol$8;
var IS_PURE = isPure;

var ITERATOR$2 = wellKnownSymbol$2('iterator');

var nativeUrl = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$2]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var redefine$1 = redefine$3;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine$1(target, key, src[key], options);
  } return target;
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var classof$1 = classof$3;
var Iterators = iterators;
var wellKnownSymbol$1 = wellKnownSymbol$8;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return it[ITERATOR$1]
    || it['@@iterator']
    || Iterators[classof$1(it)];
};

var anObject$1 = anObject$6;
var getIteratorMethod$1 = getIteratorMethod$2;

var getIterator$1 = function (it) {
  var iteratorMethod = getIteratorMethod$1(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject$1(iteratorMethod.call(it));
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $ = _export;
var getBuiltIn = getBuiltIn$2;
var USE_NATIVE_URL = nativeUrl;
var redefine = redefine$3;
var redefineAll = redefineAll$1;
var setToStringTag = setToStringTag$3;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule = internalState;
var anInstance = anInstance$1;
var hasOwn = has$7;
var bind = functionBindContext;
var classof = classof$3;
var anObject = anObject$6;
var isObject = isObject$6;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$4;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var wellKnownSymbol = wellKnownSymbol$8;

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.appent` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

var path = path$3;

var urlSearchParams$2 = path.URLSearchParams;

var parent$1 = urlSearchParams$2;

var urlSearchParams$1 = parent$1;

var parent = urlSearchParams$1;

var urlSearchParams = parent;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @internal
 */

var _WebAPIClient = /*#__PURE__*/function (_BaseAPIClient2) {
  _inherits(_WebAPIClient, _BaseAPIClient2);

  var _super = _createSuper(_WebAPIClient);

  function _WebAPIClient() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this._fetchFunction = window.fetch.bind(window);
    _this._requestClass = Request;
    return _this;
  }

  return _createClass(_WebAPIClient);
}(_BaseAPIClient);

var _localStorageStorageDriver = {
  get: function get(key) {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", window.localStorage.getItem(key));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  set: function set(key, value) {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              window.localStorage.setItem(key, value);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  del: function del(key) {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              window.localStorage.removeItem(key);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};
/**
 * @internal
 */

var PersistentTokenStorage = /*#__PURE__*/function () {
  function PersistentTokenStorage() {
    this.keyMaker = new _KeyMaker();
    this.storageDriver = new _SafeStorageDriver(_localStorageStorageDriver);
  }

  var _proto = PersistentTokenStorage.prototype;

  _proto.setRefreshToken = /*#__PURE__*/function () {
    var _setRefreshToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(namespace, refreshToken) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.storageDriver.set(this.keyMaker.keyRefreshToken(namespace), refreshToken);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function setRefreshToken(_x, _x2) {
      return _setRefreshToken.apply(this, arguments);
    }

    return setRefreshToken;
  }();

  _proto.getRefreshToken = /*#__PURE__*/function () {
    var _getRefreshToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(namespace) {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.storageDriver.get(this.keyMaker.keyRefreshToken(namespace)));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getRefreshToken(_x3) {
      return _getRefreshToken.apply(this, arguments);
    }

    return getRefreshToken;
  }();

  _proto.delRefreshToken = /*#__PURE__*/function () {
    var _delRefreshToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(namespace) {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.storageDriver.del(this.keyMaker.keyRefreshToken(namespace));

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function delRefreshToken(_x4) {
      return _delRefreshToken.apply(this, arguments);
    }

    return delRefreshToken;
  }();

  return _createClass(PersistentTokenStorage);
}();
/**
 * @internal
 */

var PersistentContainerStorage = /*#__PURE__*/function () {
  function PersistentContainerStorage() {
    this.keyMaker = new _KeyMaker();
    this.storageDriver = new _SafeStorageDriver(_localStorageStorageDriver);
  }

  var _proto2 = PersistentContainerStorage.prototype;

  _proto2.setOIDCCodeVerifier = /*#__PURE__*/function () {
    var _setOIDCCodeVerifier = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(namespace, code) {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.storageDriver.set(this.keyMaker.keyOIDCCodeVerifier(namespace), code);

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function setOIDCCodeVerifier(_x5, _x6) {
      return _setOIDCCodeVerifier.apply(this, arguments);
    }

    return setOIDCCodeVerifier;
  }();

  _proto2.setAnonymousKeyID = /*#__PURE__*/function () {
    var _setAnonymousKeyID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(namespace, kid) {
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.storageDriver.set(this.keyMaker.keyAnonymousKeyID(namespace), kid);

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function setAnonymousKeyID(_x7, _x8) {
      return _setAnonymousKeyID.apply(this, arguments);
    }

    return setAnonymousKeyID;
  }();

  _proto2.setBiometricKeyID = /*#__PURE__*/function () {
    var _setBiometricKeyID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(namespace, kid) {
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.storageDriver.set(this.keyMaker.keyBiometricKeyID(namespace), kid);

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function setBiometricKeyID(_x9, _x10) {
      return _setBiometricKeyID.apply(this, arguments);
    }

    return setBiometricKeyID;
  }();

  _proto2.getOIDCCodeVerifier = /*#__PURE__*/function () {
    var _getOIDCCodeVerifier = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10(namespace) {
      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.storageDriver.get(this.keyMaker.keyOIDCCodeVerifier(namespace)));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getOIDCCodeVerifier(_x11) {
      return _getOIDCCodeVerifier.apply(this, arguments);
    }

    return getOIDCCodeVerifier;
  }();

  _proto2.getAnonymousKeyID = /*#__PURE__*/function () {
    var _getAnonymousKeyID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(namespace) {
      return regenerator.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.storageDriver.get(this.keyMaker.keyAnonymousKeyID(namespace)));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getAnonymousKeyID(_x12) {
      return _getAnonymousKeyID.apply(this, arguments);
    }

    return getAnonymousKeyID;
  }();

  _proto2.getBiometricKeyID = /*#__PURE__*/function () {
    var _getBiometricKeyID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(namespace) {
      return regenerator.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.storageDriver.get(this.keyMaker.keyBiometricKeyID(namespace)));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getBiometricKeyID(_x13) {
      return _getBiometricKeyID.apply(this, arguments);
    }

    return getBiometricKeyID;
  }();

  _proto2.delOIDCCodeVerifier = /*#__PURE__*/function () {
    var _delOIDCCodeVerifier = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13(namespace) {
      return regenerator.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.storageDriver.del(this.keyMaker.keyOIDCCodeVerifier(namespace));

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function delOIDCCodeVerifier(_x14) {
      return _delOIDCCodeVerifier.apply(this, arguments);
    }

    return delOIDCCodeVerifier;
  }();

  _proto2.delAnonymousKeyID = /*#__PURE__*/function () {
    var _delAnonymousKeyID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14(namespace) {
      return regenerator.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.storageDriver.del(this.keyMaker.keyAnonymousKeyID(namespace));

            case 2:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function delAnonymousKeyID(_x15) {
      return _delAnonymousKeyID.apply(this, arguments);
    }

    return delAnonymousKeyID;
  }();

  _proto2.delBiometricKeyID = /*#__PURE__*/function () {
    var _delBiometricKeyID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee15(namespace) {
      return regenerator.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.storageDriver.del(this.keyMaker.keyBiometricKeyID(namespace));

            case 2:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function delBiometricKeyID(_x16) {
      return _delBiometricKeyID.apply(this, arguments);
    }

    return delBiometricKeyID;
  }();

  return _createClass(PersistentContainerStorage);
}();

function byteToHex(byte) {
  return ("0" + byte.toString(16)).substr(-2);
} // windowCryptoSubtleDigest is window.crypto.subtle.digest with IE 11 support.


function windowCryptoSubtleDigest(_x, _x2) {
  return _windowCryptoSubtleDigest.apply(this, arguments);
}

function _windowCryptoSubtleDigest() {
  _windowCryptoSubtleDigest = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(algorithm, data) {
    var promiseOrEvent;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promiseOrEvent = window.crypto.subtle.digest(algorithm, data.buffer); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

            if (!promiseOrEvent.then) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", promiseOrEvent.then(function (output) {
              return new Uint8Array(output);
            }));

          case 3:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              promiseOrEvent.oncomplete = function (output) {
                resolve(new Uint8Array(output));
              };

              promiseOrEvent.onerror = function (err) {
                reject(err);
              };
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _windowCryptoSubtleDigest.apply(this, arguments);
}

function sha256(_x3) {
  return _sha.apply(this, arguments);
}

function _sha() {
  _sha = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(s) {
    var bytes;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            bytes = _encodeUTF8(s);
            return _context2.abrupt("return", windowCryptoSubtleDigest("SHA-256", bytes));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _sha.apply(this, arguments);
}

function computeCodeChallenge(_x4) {
  return _computeCodeChallenge.apply(this, arguments);
}

function _computeCodeChallenge() {
  _computeCodeChallenge = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(codeVerifier) {
    var hash, base64;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return sha256(codeVerifier);

          case 2:
            hash = _context3.sent;
            base64 = _base64URLEncode(hash);
            return _context3.abrupt("return", base64);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _computeCodeChallenge.apply(this, arguments);
}

function generateCodeVerifier() {
  var arr = new Uint8Array(32);
  window.crypto.getRandomValues(arr);
  var output = "";

  for (var i = 0; i < arr.length; ++i) {
    output += byteToHex(arr[i]);
  }

  return output;
}

/**
 * Web Container
 *
 * @public
 */
var WebContainer = /*#__PURE__*/function () {
  function WebContainer(options) {
    var o = _extends({}, options);

    var apiClient = new _WebAPIClient();
    this.baseContainer = new _BaseContainer(o, apiClient, this);
    this.baseContainer.apiClient._delegate = this;
    this.storage = new PersistentContainerStorage();
    this.tokenStorage = new PersistentTokenStorage();
    this.sessionType = "refresh_token";
  }
  /**
   * implements _APIClientDelegate
   *
   * @internal
   */


  var _proto = WebContainer.prototype;

  _proto.getAccessToken = function getAccessToken() {
    return this.baseContainer.accessToken;
  }
  /**
   * implements _APIClientDelegate
   *
   * @internal
   */
  ;

  _proto.shouldRefreshAccessToken = function shouldRefreshAccessToken() {
    return this.baseContainer.shouldRefreshAccessToken();
  }
  /**
   * implements _BaseContainerDelegate
   *
   * @internal
   */
  ;

  _proto.onSessionStateChange = function onSessionStateChange(reason) {
    var _this$delegate;

    (_this$delegate = this.delegate) == null ? void 0 : _this$delegate.onSessionStateChange(this, reason);
  }
  /**
   * getIDTokenHint() returns the ID token for the OIDC id_token_hint parameter.
   *
   * @public
   */
  ;

  _proto.getIDTokenHint = function getIDTokenHint() {
    return this.baseContainer.getIDTokenHint();
  }
  /**
   * canReauthenticate() reports whether the current user can reauthenticate.
   * The information comes from the ID token and the ID token is NOT verified.
   *
   * @public
   */
  ;

  _proto.canReauthenticate = function canReauthenticate() {
    return this.baseContainer.canReauthenticate();
  }
  /**
   * getAuthTime() reports the last time the user was authenticated.
   * The information comes from the ID token and the ID token is NOT verified.
   *
   * @public
   */
  ;

  _proto.getAuthTime = function getAuthTime() {
    return this.baseContainer.getAuthTime();
  }
  /**
   * refreshIDToken() asks the server to issue an ID token with latest claims.
   * After refreshing, getIDTokenHint() and canReauthenticate() may return up-to-date value.
   *
   * @public
   */
  ;

  _proto.refreshIDToken =
  /*#__PURE__*/
  function () {
    var _refreshIDToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.refreshAccessTokenIfNeeded();

            case 2:
              return _context.abrupt("return", this.baseContainer.refreshIDToken());

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function refreshIDToken() {
      return _refreshIDToken.apply(this, arguments);
    }

    return refreshIDToken;
  }()
  /**
   * configure() configures the container with the client ID and the endpoint.
   * It also does local IO to retrieve the refresh token.
   * It only obtains the refresh token locally and no network call will
   * be triggered. So the session state maybe outdated for some reason, e.g.
   * user session is revoked. fetchUserInfo should be called to obtain the
   * latest user session state.
   *
   * configure() can be called more than once if it failed.
   * Otherwise, it is NOT recommended to call it more than once.
   *
   * @public
   */
  ;

  _proto.configure =
  /*#__PURE__*/
  function () {
    var _configure = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(options) {
      var refreshToken;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.tokenStorage.getRefreshToken(this.name);

            case 2:
              refreshToken = _context2.sent;
              this.clientID = options.clientID;
              this.baseContainer.apiClient.endpoint = options.endpoint;

              if (options.sessionType != null) {
                this.sessionType = options.sessionType;
              }

              this.baseContainer.refreshToken = refreshToken != null ? refreshToken : undefined;
              _context2.t0 = this.sessionType;
              _context2.next = _context2.t0 === "cookie" ? 10 : _context2.t0 === "refresh_token" ? 12 : 14;
              break;

            case 10:
              this.baseContainer._updateSessionState("UNKNOWN", "NO_TOKEN");

              return _context2.abrupt("break", 14);

            case 12:
              if (this.baseContainer.refreshToken != null) {
                // consider user as logged in if refresh token is available
                this.baseContainer._updateSessionState("AUTHENTICATED", "FOUND_TOKEN");
              } else {
                this.baseContainer._updateSessionState("NO_SESSION", "NO_TOKEN");
              }

              return _context2.abrupt("break", 14);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function configure(_x) {
      return _configure.apply(this, arguments);
    }

    return configure;
  }()
  /**
   * @internal
   */
  // eslint-disable-next-line class-methods-use-this
  ;

  _proto._setupCodeVerifier =
  /*#__PURE__*/
  function () {
    var _setupCodeVerifier2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var codeVerifier, codeChallenge;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              codeVerifier = generateCodeVerifier();
              _context3.next = 3;
              return computeCodeChallenge(codeVerifier);

            case 3:
              codeChallenge = _context3.sent;
              return _context3.abrupt("return", {
                verifier: codeVerifier,
                challenge: codeChallenge
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function _setupCodeVerifier() {
      return _setupCodeVerifier2.apply(this, arguments);
    }

    return _setupCodeVerifier;
  }()
  /**
   * Start authentication by redirecting to the authorization endpoint.
   */
  ;

  _proto.startAuthentication =
  /*#__PURE__*/
  function () {
    var _startAuthentication = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(options) {
      var authorizeEndpoint;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.authorizeEndpoint(options);

            case 2:
              authorizeEndpoint = _context4.sent;
              window.location.href = authorizeEndpoint;

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function startAuthentication(_x2) {
      return _startAuthentication.apply(this, arguments);
    }

    return startAuthentication;
  }()
  /**
   * Start reauthentication by redirecting to the authorization endpoint.
   */
  ;

  _proto.startReauthentication =
  /*#__PURE__*/
  function () {
    var _startReauthentication = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(options) {
      var _options$maxAge;

      var idToken, maxAge, endpoint;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              idToken = this.getIDTokenHint();

              if (!(idToken == null || !this.canReauthenticate())) {
                _context5.next = 3;
                break;
              }

              throw new Error("You can only trigger reauthentication when canReauthenticate() returns true");

            case 3:
              maxAge = (_options$maxAge = options.maxAge) != null ? _options$maxAge : 0;
              _context5.next = 6;
              return this.baseContainer.authorizeEndpoint(_extends({}, options, {
                maxAge: maxAge,
                idTokenHint: idToken,
                responseType: "code",
                scope: ["openid", "https://authgear.com/scopes/full-access"]
              }));

            case 6:
              endpoint = _context5.sent;
              window.location.href = endpoint;

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function startReauthentication(_x3) {
      return _startReauthentication.apply(this, arguments);
    }

    return startReauthentication;
  }()
  /**
   * Start promote anonymous user by redirecting to the authorization endpoint.
   */
  ;

  _proto.startPromoteAnonymousUser =
  /*#__PURE__*/
  function () {
    var _startPromoteAnonymousUser = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(options) {
      var _yield$this$tokenStor;

      var refreshToken, _yield$this$baseConta, promotion_code, loginHint, authorizeEndpoint;

      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(this.sessionType === "cookie")) {
                _context6.next = 4;
                break;
              }

              _context6.t0 = undefined;
              _context6.next = 13;
              break;

            case 4:
              _context6.next = 6;
              return this.tokenStorage.getRefreshToken(this.name);

            case 6:
              _context6.t1 = _yield$this$tokenStor = _context6.sent;

              if (!(_context6.t1 != null)) {
                _context6.next = 11;
                break;
              }

              _context6.t2 = _yield$this$tokenStor;
              _context6.next = 12;
              break;

            case 11:
              _context6.t2 = undefined;

            case 12:
              _context6.t0 = _context6.t2;

            case 13:
              refreshToken = _context6.t0;
              _context6.next = 16;
              return this.baseContainer.apiClient.anonymousUserPromotionCode(this.sessionType, refreshToken);

            case 16:
              _yield$this$baseConta = _context6.sent;
              promotion_code = _yield$this$baseConta.promotion_code;
              loginHint = "https://authgear.com/login_hint?type=anonymous&promotion_code=".concat(encodeURIComponent(promotion_code));
              _context6.next = 21;
              return this.authorizeEndpoint(_extends({}, options, {
                prompt: "login",
                loginHint: loginHint
              }));

            case 21:
              authorizeEndpoint = _context6.sent;
              window.location.href = authorizeEndpoint;

            case 23:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function startPromoteAnonymousUser(_x4) {
      return _startPromoteAnonymousUser.apply(this, arguments);
    }

    return startPromoteAnonymousUser;
  }()
  /**
   * Finish authentication.
   *
   * It may reject with OAuthError.
   */
  ;

  _proto.finishAuthentication =
  /*#__PURE__*/
  function () {
    var _finishAuthentication = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.baseContainer._finishAuthentication(window.location.href));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function finishAuthentication() {
      return _finishAuthentication.apply(this, arguments);
    }

    return finishAuthentication;
  }()
  /**
   * Finish reauthentication.
   *
   * It may reject with OAuthError.
   */
  ;

  _proto.finishReauthentication =
  /*#__PURE__*/
  function () {
    var _finishReauthentication = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8() {
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.baseContainer._finishReauthentication(window.location.href));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function finishReauthentication() {
      return _finishReauthentication.apply(this, arguments);
    }

    return finishReauthentication;
  }()
  /**
   * Finish promote anonymous user.
   *
   * It may reject with OAuthError.
   */
  ;

  _proto.finishPromoteAnonymousUser =
  /*#__PURE__*/
  function () {
    var _finishPromoteAnonymousUser = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9() {
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.baseContainer._finishAuthentication(window.location.href));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function finishPromoteAnonymousUser() {
      return _finishPromoteAnonymousUser.apply(this, arguments);
    }

    return finishPromoteAnonymousUser;
  }()
  /**
   * Open the URL with the user agent authenticated with current user.
   *
   * @internal
   */
  ;

  _proto.openURL =
  /*#__PURE__*/
  function () {
    var _openURL = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10(url, options) {
      var u, q, targetURL, refreshToken, _yield$this$baseConta2, app_session_token, loginHint;

      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              u = new URL(url);
              q = u.searchParams;

              if ((options == null ? void 0 : options.uiLocales) != null) {
                q.set("ui_locales", options.uiLocales.join(" "));
              }

              u.search = "?" + q.toString();
              targetURL = u.toString(); // use authorize endpoint with app_session_token to open the setting page only
              // if session type is refresh_token

              if (!(this.sessionType === "refresh_token")) {
                _context10.next = 19;
                break;
              }

              _context10.next = 8;
              return this.tokenStorage.getRefreshToken(this.name);

            case 8:
              refreshToken = _context10.sent;

              if (refreshToken) {
                _context10.next = 11;
                break;
              }

              throw new AuthgearError("refresh token not found");

            case 11:
              _context10.next = 13;
              return this.baseContainer.apiClient.appSessionToken(refreshToken);

            case 13:
              _yield$this$baseConta2 = _context10.sent;
              app_session_token = _yield$this$baseConta2.app_session_token;
              loginHint = "https://authgear.com/login_hint?type=app_session_token&app_session_token=".concat(encodeURIComponent(app_session_token));
              _context10.next = 18;
              return this.authorizeEndpoint({
                redirectURI: targetURL,
                prompt: "none",
                responseType: "none",
                loginHint: loginHint
              });

            case 18:
              targetURL = _context10.sent;

            case 19:
              if (options != null && options.openInSameTab) {
                window.location.href = targetURL;
              } else {
                window.open(targetURL, "_blank");
              }

            case 20:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function openURL(_x5, _x6) {
      return _openURL.apply(this, arguments);
    }

    return openURL;
  }();

  _proto.open = /*#__PURE__*/function () {
    var _open = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(page, options) {
      var endpoint, endpointWithoutTrailingSlash;
      return regenerator.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              endpoint = this.baseContainer.apiClient.endpoint;

              if (!(endpoint == null)) {
                _context11.next = 3;
                break;
              }

              throw new AuthgearError("Endpoint cannot be undefined, please double check whether you have run configure()");

            case 3:
              endpointWithoutTrailingSlash = endpoint.replace(/\/$/, "");
              _context11.next = 6;
              return this.openURL("".concat(endpointWithoutTrailingSlash).concat(page), options);

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function open(_x7, _x8) {
      return _open.apply(this, arguments);
    }

    return open;
  }()
  /**
   * Logout.
   *
   * @remarks
   * If `force` parameter is set to `true`, all potential errors (e.g. network
   * error) would be ignored.
   *
   * `redirectURI` is required. User will be redirected to the uri after they
   * have logged out.
   *
   * @param options - Logout options
   */
  ;

  _proto.logout =
  /*#__PURE__*/
  function () {
    var _logout = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(options) {
      return regenerator.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (options === void 0) {
                options = {
                  redirectURI: ""
                };
              }

              if (options.redirectURI) {
                _context12.next = 3;
                break;
              }

              throw new AuthgearError("missing redirect uri");

            case 3:
              _context12.t0 = this.sessionType;
              _context12.next = _context12.t0 === "cookie" ? 6 : _context12.t0 === "refresh_token" ? 9 : 12;
              break;

            case 6:
              _context12.next = 8;
              return this._logoutCookie(options);

            case 8:
              return _context12.abrupt("break", 12);

            case 9:
              _context12.next = 11;
              return this._logoutRefreshToken(options);

            case 11:
              return _context12.abrupt("break", 12);

            case 12:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function logout(_x9) {
      return _logout.apply(this, arguments);
    }

    return logout;
  }()
  /**
   * Authenticate as an anonymous user.
   */
  ;

  _proto.authenticateAnonymously =
  /*#__PURE__*/
  function () {
    var _authenticateAnonymously = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13() {
      var clientID, sessionType, userInfo, refreshToken, tokenResponse, _userInfo;

      return regenerator.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context13.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              sessionType = this.sessionType;
              _context13.t0 = this.sessionType;
              _context13.next = _context13.t0 === "cookie" ? 7 : _context13.t0 === "refresh_token" ? 13 : 27;
              break;

            case 7:
              _context13.next = 9;
              return this.baseContainer.apiClient.signupAnonymousUserWithoutKey(clientID, sessionType, undefined);

            case 9:
              _context13.next = 11;
              return this.baseContainer.apiClient._oidcUserInfoRequest();

            case 11:
              userInfo = _context13.sent;
              return _context13.abrupt("return", {
                userInfo: userInfo
              });

            case 13:
              _context13.next = 15;
              return this.tokenStorage.getRefreshToken(this.name);

            case 15:
              refreshToken = _context13.sent;
              _context13.next = 18;
              return this.baseContainer.apiClient.signupAnonymousUserWithoutKey(clientID, sessionType, refreshToken != null ? refreshToken : undefined);

            case 18:
              tokenResponse = _context13.sent;

              if (tokenResponse) {
                _context13.next = 21;
                break;
              }

              throw new AuthgearError("unexpected empty token response");

            case 21:
              _context13.next = 23;
              return this.baseContainer._persistTokenResponse(tokenResponse, "AUTHENTICATED");

            case 23:
              _context13.next = 25;
              return this.baseContainer.apiClient._oidcUserInfoRequest(tokenResponse.access_token);

            case 25:
              _userInfo = _context13.sent;
              return _context13.abrupt("return", {
                userInfo: _userInfo
              });

            case 27:
              throw new AuthgearError("unknown session type");

            case 28:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function authenticateAnonymously() {
      return _authenticateAnonymously.apply(this, arguments);
    }

    return authenticateAnonymously;
  }();

  _proto._logoutRefreshToken = /*#__PURE__*/function () {
    var _logoutRefreshToken2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14(options) {
      var _yield$this$tokenStor2;

      var refreshToken;
      return regenerator.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.tokenStorage.getRefreshToken(this.name);

            case 2:
              _context14.t0 = _yield$this$tokenStor2 = _context14.sent;

              if (!(_context14.t0 != null)) {
                _context14.next = 7;
                break;
              }

              _context14.t1 = _yield$this$tokenStor2;
              _context14.next = 8;
              break;

            case 7:
              _context14.t1 = "";

            case 8:
              refreshToken = _context14.t1;

              if (!(refreshToken !== "")) {
                _context14.next = 21;
                break;
              }

              _context14.prev = 10;
              _context14.next = 13;
              return this.baseContainer.apiClient._oidcRevocationRequest(refreshToken);

            case 13:
              _context14.next = 19;
              break;

            case 15:
              _context14.prev = 15;
              _context14.t2 = _context14["catch"](10);

              if (options.force) {
                _context14.next = 19;
                break;
              }

              throw _context14.t2;

            case 19:
              _context14.next = 21;
              return this.baseContainer._clearSession("LOGOUT");

            case 21:
              _context14.next = 23;
              return this._redirectToEndSessionEndpoint(options.redirectURI);

            case 23:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this, [[10, 15]]);
    }));

    function _logoutRefreshToken(_x10) {
      return _logoutRefreshToken2.apply(this, arguments);
    }

    return _logoutRefreshToken;
  }();

  _proto._logoutCookie = /*#__PURE__*/function () {
    var _logoutCookie2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee15(options) {
      return regenerator.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this._redirectToEndSessionEndpoint(options.redirectURI);

            case 2:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function _logoutCookie(_x11) {
      return _logoutCookie2.apply(this, arguments);
    }

    return _logoutCookie;
  }() // Redirect to end_session_endpoint and logout idp session
  ;

  _proto._redirectToEndSessionEndpoint =
  /*#__PURE__*/
  function () {
    var _redirectToEndSessionEndpoint2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee16(redirectURI) {
      var clientID, config, query, endSessionEndpoint;
      return regenerator.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              clientID = this.clientID;

              if (!(clientID == null)) {
                _context16.next = 3;
                break;
              }

              throw new AuthgearError("missing client ID");

            case 3:
              _context16.next = 5;
              return this.baseContainer.apiClient._fetchOIDCConfiguration();

            case 5:
              config = _context16.sent;
              query = new urlSearchParams();

              if (redirectURI) {
                query.append("post_logout_redirect_uri", redirectURI);
              }

              endSessionEndpoint = "".concat(config.end_session_endpoint, "?").concat(query.toString());
              window.location.href = endSessionEndpoint;

            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function _redirectToEndSessionEndpoint(_x12) {
      return _redirectToEndSessionEndpoint2.apply(this, arguments);
    }

    return _redirectToEndSessionEndpoint;
  }()
  /**
   * @internal
   */
  ;

  _proto.authorizeEndpoint =
  /*#__PURE__*/
  function () {
    var _authorizeEndpoint = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee17(options) {
      var _options$responseType;

      var responseType, scope, suppressIDPSessionCookie;
      return regenerator.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              // Use shared session cookie by default for first-party web apps.
              responseType = ((_options$responseType = options.responseType) != null ? _options$responseType : this.sessionType === "cookie") ? "none" : "code";
              scope = this.sessionType === "cookie" ? ["openid", "https://authgear.com/scopes/full-access"] : ["openid", "offline_access", "https://authgear.com/scopes/full-access"];
              suppressIDPSessionCookie = this.sessionType === "refresh_token";
              return _context17.abrupt("return", this.baseContainer.authorizeEndpoint(_extends({}, options, {
                responseType: responseType,
                scope: scope,
                suppressIDPSessionCookie: suppressIDPSessionCookie
              })));

            case 4:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function authorizeEndpoint(_x13) {
      return _authorizeEndpoint.apply(this, arguments);
    }

    return authorizeEndpoint;
  }()
  /**
   * Make authorize URL makes authorize URL based on options.
   *
   * This function will be used if developer wants to redirection in their own
   * code.
   */
  ;

  _proto.makeAuthorizeURL =
  /*#__PURE__*/
  function () {
    var _makeAuthorizeURL = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee18(options) {
      return regenerator.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", this.authorizeEndpoint(options));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    function makeAuthorizeURL(_x14) {
      return _makeAuthorizeURL.apply(this, arguments);
    }

    return makeAuthorizeURL;
  }()
  /**
   * Fetch user info.
   */
  ;

  _proto.fetchUserInfo =
  /*#__PURE__*/
  function () {
    var _fetchUserInfo = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee19() {
      var _this$accessToken;

      return regenerator.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.refreshAccessTokenIfNeeded();

            case 2:
              return _context19.abrupt("return", this.baseContainer.apiClient._oidcUserInfoRequest(this.sessionType === "cookie" ? undefined : (_this$accessToken = this.accessToken) != null ? _this$accessToken : ""));

            case 3:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));

    function fetchUserInfo() {
      return _fetchUserInfo.apply(this, arguments);
    }

    return fetchUserInfo;
  }()
  /**
   * implements _BaseContainerDelegate
   *
   * @internal
   */
  ;

  _proto.refreshAccessToken =
  /*#__PURE__*/
  function () {
    var _refreshAccessToken = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee20() {
      return regenerator.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.baseContainer._refreshAccessToken();

            case 2:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));

    function refreshAccessToken() {
      return _refreshAccessToken.apply(this, arguments);
    }

    return refreshAccessToken;
  }()
  /**
   * @public
   */
  ;

  _proto.refreshAccessTokenIfNeeded =
  /*#__PURE__*/
  function () {
    var _refreshAccessTokenIfNeeded = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee21() {
      return regenerator.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", this.baseContainer.refreshAccessTokenIfNeeded());

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));

    function refreshAccessTokenIfNeeded() {
      return _refreshAccessTokenIfNeeded.apply(this, arguments);
    }

    return refreshAccessTokenIfNeeded;
  }()
  /**
   * Fetch function for you to call your application server.
   * The fetch function will include Authorization header in your application
   * request, and handle refresh access token automatically.
   *
   * @public
   */
  ;

  _proto.fetch =
  /*#__PURE__*/
  function () {
    var _fetch = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee22(input, init) {
      return regenerator.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", this.baseContainer.fetch(input, init));

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));

    function fetch(_x15, _x16) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }();

  _createClass(WebContainer, [{
    key: "name",
    get:
    /**
     * @internal
     */

    /**
     * @internal
     */

    /**
     * @internal
     */

    /**
     * @public
     */

    /**
     * @public
     */

    /**
     *
     * Unique ID for this container.
     * @defaultValue "default"
     *
     * @public
     */
    function get() {
      return this.baseContainer.name;
    },
    set: function set(name) {
      this.baseContainer.name = name;
    }
    /**
     * OIDC client ID
     *
     * @public
     */

  }, {
    key: "clientID",
    get: function get() {
      return this.baseContainer.clientID;
    },
    set: function set(clientID) {
      this.baseContainer.clientID = clientID;
    }
    /**
     *
     * @public
     */

  }, {
    key: "sessionState",
    get: function get() {
      return this.baseContainer.sessionState;
    },
    set: function set(sessionState) {
      this.baseContainer.sessionState = sessionState;
    }
    /**
     *
     * @public
     */

  }, {
    key: "accessToken",
    get: function get() {
      return this.baseContainer.accessToken;
    },
    set: function set(accessToken) {
      this.baseContainer.accessToken = accessToken;
    }
  }]);

  return WebContainer;
}();

/**
 * Default container.
 *
 * @remarks
 * This is a global shared container, provided for convenience.
 *
 * @public
 */

var defaultContainer = new WebContainer();

export { AuthgearError, CancelError, ErrorNames, OAuthError, Page, ServerError, TransientTokenStorage, VERSION, WebContainer, _BaseAPIClient, _BaseContainer, _KeyMaker, _MemoryStorageDriver, _SafeStorageDriver, _base64URLDecode, _base64URLEncode, _canReauthenticate, _decodeError, _decodeIDToken, _decodeUTF8, _decodeUserInfo, _encodeUTF8, _getAuthTime, _removeTrailingSlash, defaultContainer as default };
